import React, { useState, useEffect, useRef } from "react";
import emailjs from "@emailjs/browser";

import IdealAbasan_block_c1 from "../images/IdealAbasan_block_c1.jpeg";
import IdealAbasan_block_c2 from "../images/IdealAbasan_block_c2.jpeg";
import IdealAbasan_block_c3 from "../images/IdealAbasan_block_c3.jpeg";
import IdealAbasan_block_c4 from "../images/IdealAbasan_block_c4.jpeg";
import IdealAbasan_block_c5 from "../images/IdealAbasan_block_c5.jpeg";
import IdealAbasan_block_c6 from "../images/IdealAbasan_block_c6.jpeg";
import IdealAbasan_block_c7 from "../images/IdealAbasan_block_c7.jpeg";
import IdealAbasan_block_c8 from "../images/IdealAbasan_block_c8.jpeg";
import IdealAbasan_block_c9 from "../images/IdealAbasan_block_c9.jpeg";
import IdealAbasan_block_c10 from "../images/IdealAbasan_block_c10.jpeg";
import IdealAbasan_block_c11 from "../images/IdealAbasan_block_c11.jpeg";
import IdealAbasan_block_c12 from "../images/IdealAbasan_block_c12.jpeg";
import IdealAbasan_block_c13 from "../images/IdealAbasan_block_c13.jpeg";
import IdealAbasan_block_j1 from "../images/IdealAbasan_block_j1.jpeg";
import IdealAbasan_block_j2 from "../images/IdealAbasan_block_j2.jpeg";
import IdealAbasan_block_j3 from "../images/IdealAbasan_block_j3.jpeg";
import IdealAbasan_block_j4 from "../images/IdealAbasan_block_j4.jpeg";
import IdealAbasan_block_j5 from "../images/IdealAbasan_block_j5.jpeg";
import IdealAbasan_block_j6 from "../images/IdealAbasan_block_j6.jpeg";
import IdealAbasan_block_j7 from "../images/IdealAbasan_block_j7.jpeg";
import IdealAbasan_block_E1 from "../images/IdealAbasan_block_E1.jpeg";
import IdealAbasan_block_E2 from "../images/IdealAbasan_block_E2.jpeg";
import IdealAbasan_block_E3 from "../images/IdealAbasan_block_E3.jpeg";
import IdealAbasan_block_E5 from "../images/IdealAbasan_block_E5.jpeg";
import IdealAbasan_block_E6 from "../images/IdealAbasan_block_E6.jpeg";
import IdealAbasan_block_E7 from "../images/IdealAbasan_block_E7.jpeg";
import IdealAbasan_block_E8 from "../images/IdealAbasan_block_E8.jpeg";
import IdealAbasan_block_F1 from "../images/IdealAbasan_block_F1.jpeg";
import IdealAbasan_block_F2 from "../images/IdealAbasan_block_F2.jpeg";
import IdealAbasan_block_F3 from "../images/IdealAbasan_block_F3.jpeg";
import IdealAbasan_block_F4 from "../images/IdealAbasan_block_F4.jpeg";
import IdealAbasan_block_F6 from "../images/IdealAbasan_block_F6.jpeg";
import IdealAbasan_block_F7 from "../images/IdealAbasan_block_F7.jpeg";
import IdealAbasan_block_F8 from "../images/IdealAbasan_block_F8.jpeg";
import IdealAbasan_block_F9 from "../images/IdealAbasan_block_F9.jpeg";
import IdealAbasan_block_F11 from "../images/IdealAbasan_block_F11.jpeg";
import IdealAbasan4E1 from "../images/IdealAbasan4E1.jpeg";
import IdealAbasan4E2 from "../images/IdealAbasan4E2.jpeg";
import IdealAbasan4E3 from "../images/IdealAbasan4E3.jpeg";
import IdealAbasan4E4 from "../images/IdealAbasan4E4.jpeg";
import IdealAbasan4E5 from "../images/IdealAbasan4E5.jpeg";
import IdealAbasan4E6 from "../images/IdealAbasan4E6.jpeg";
import IdealAbasan4E7 from "../images/IdealAbasan4E7.jpeg";
import IdealAbasan4E8 from "../images/IdealAbasan4E8.jpeg";
import IdealAbasan4E9 from "../images/IdealAbasan4E9.jpeg";
import PritiSamabayAbasanSamiti1 from "../images/PritiSamabayAbasanSamiti1.jpeg";
import PritiSamabayAbasanSamiti2 from "../images/PritiSamabayAbasanSamiti2.jpeg";
import PritiSamabayAbasanSamiti3 from "../images/PritiSamabayAbasanSamiti3.jpeg";
import PritiSamabayAbasanSamiti4 from "../images/PritiSamabayAbasanSamiti4.jpeg";
import PritiSamabayAbasanSamiti5 from "../images/PritiSamabayAbasanSamiti5.jpeg";
import PritiSamabayAbasanSamiti6 from "../images/PritiSamabayAbasanSamiti6.jpeg";
import PritiSamabayAbasanSamiti7 from "../images/PritiSamabayAbasanSamiti7.jpeg";
import PallabPalDipaKSarkar1 from "../images/PallabPal&DipaKSarkar1.jpeg";
import PallabPalDipaKSarkar2 from "../images/PallabPal&DipaKSarkar2.jpeg";
import PallabPalDipaKSarkar3 from "../images/PallabPal&DipaKSarkar3.jpeg";
import PallabPalDipaKSarkar4 from "../images/PallabPal&DipaKSarkar4.jpeg";
import PallabPalDipaKSarkar5 from "../images/PallabPal&DipaKSarkar5.jpeg";
import PallabPalDipaKSarkar7 from "../images/PallabPal&DipaKSarkar7.jpeg";
import PallabPalDipaKSarkar8 from "../images/PallabPal&DipaKSarkar8.jpeg";
import sunriseb1 from "../images/sunriseb1.jpg";
import sunriseb2 from "../images/sunriseb2.jpg";
import sunriseb3 from "../images/sunriseb3.jpg";
import sunriseb4 from "../images/sunriseb4.jpg";
import sunriseb5 from "../images/sunriseb5.jpg";
import sunriseb7 from "../images/sunriseb7.jpg";
import sunriseb8 from "../images/sunriseb8.jpg";
import urbanvistaa3 from "../images/urbanvistaa3.jpg";
import urbanvistaa4 from "../images/urbanvistaa4.jpg";
import urbanvistaa5 from "../images/urbanvistaa5.jpg";
import urbanvistaa6 from "../images/urbanvistaa6.jpg";
import urbanvistaa8 from "../images/urbanvistaa8.jpg";

// ─── NEW PROPERTY 22: INDIVIDUAL BUILDING (COMMERCIAL) ──────────────────
import IndividualBuilding_image1 from "../images/IndividualBuilding_image1.jpeg";
import IndividualBuilding_image2 from "../images/IndividualBuilding_image2.jpeg";
import IndividualBuilding_image3 from "../images/IndividualBuilding_image3.jpeg";
import IndividualBuilding_image4 from "../images/IndividualBuilding_image4.jpeg";
import IndividualBuilding_image5 from "../images/IndividualBuilding_image5.jpeg";

// ─── NEW PROPERTY 23: NBCC VIBGYOR TOWER ──────────────────────────────
import NBCCVibgyorTower_image2 from "../images/NBCCVibgyorTower_image2.jpeg";
import NBCCVibgyorTower_image3 from "../images/NBCCVibgyorTower_image3.jpeg";
import NBCCVibgyorTower_image4 from "../images/NBCCVibgyorTower_image4.jpeg";
import NBCCVibgyorTower_image5 from "../images/NBCCVibgyorTower_image5.jpeg";
import NBCCVibgyorTower_vedio from "../images/NBCCVibgyorTower_image1.mp4";

// ─── NEW PROPERTY 24: URBAN VISTA PHASE 1 ──────────────────────────────
import UrbanVistaPhase1_image1 from "../images/UrbanVistaPhase1_image1.jpeg";
import UrbanVistaPhase1_image2 from "../images/UrbanVistaPhase1_image2.jpeg";
import UrbanVistaPhase1_image3 from "../images/UrbanVistaPhase1_image3.jpeg";
import UrbanVistaPhase1_image4 from "../images/UrbanVistaPhase1_image4.jpeg";
import UrbanVistaPhase1_image5 from "../images/UrbanVistaPhase1_image5.jpeg";
import UrbanVistaPhase1_vedio from "../images/UrbanVistaPhase1_vedio.mp4";

// ─── NEW PROPERTY 25: URBAN VISTA PHASE 1 - 2BHK (RECKJOANI) ──────────
import Reckjoani_image1 from "../images/Reckjoani_image1.jpeg";
import Reckjoani_image2 from "../images/Reckjoani_image2.jpeg";
import Reckjoani_image3 from "../images/Reckjoani_image3.jpeg";
import Reckjoani_image5 from "../images/Reckjoani_image5.jpeg";
import Reckjoani_image6 from "../images/Reckjoani_image6.jpeg";
import Reckjoani_image7 from "../images/Reckjoani_image7.jpeg";

// ─── VIDEO IMPORTS (for direct MP4 usage) ──────────────────────────────────
import IdealAbasan_vedio from "../images/IdealAbasan_vedio.mp4";
import IdealAbasan_block_j_vedio from "../images/IdealAbasan_block_j_vedio.mp4";
import IdealAbasan_block_E_vedio from "../images/IdealAbasan_block_E_vedio.jpeg";
import IdealAbasan4E_vedio from "../images/IdealAbasan4E_vedio.mp4";
import urbar_vista_image from "../images/urbar_vista_image.mp4";
import SunriseGreens_images from "../images/SunriseGreens_images.mp4";
import PritiSamabayAbasanSamiti_vedio from "../images/PritiSamabayAbasanSamiti_vedio.mp4";
import PallabPalDipaKSarkar1Vedio from "../images/PallabPal&DipaKSarkar1Vedio.mp4";
import Reckjoani_image8 from "../images/Reckjoani_image8.jpeg";
import Reckjoani_image9 from "../images/Reckjoani_image9.jpeg";
import Reckjoani_image10 from "../images/Reckjoani_image10.jpeg";
// ─── DEFAULT PLACEHOLDER IMAGE ─────────────────────────────────────────────
const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1560448204-603b3fc33ddc?w=800&q=80";

// ─── BACKGROUND IMAGES (using Unsplash for backgrounds) ──────────────────
const IMAGES = {
  hero: "https://images.unsplash.com/photo-1558431382-27e303142255?w=1800&q=80",
  projects: "https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=1800&q=80",
  localities: "https://images.unsplash.com/photo-1536575695483-8ec8cdfbdccf?w=1800&q=80",
  exclusive: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1800&q=80",
  testimonials: "https://images.unsplash.com/photo-1560448204-603b3fc33ddc?w=1800&q=80",
  developers: "https://images.unsplash.com/photo-1448630360428-65456885c650?w=1800&q=80",
  cta: "https://images.unsplash.com/photo-1600210492493-0946911123ea?w=1800&q=80",
  divider1: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1800&q=80",
  divider2: "https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=1800&q=80",
  divider3: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1800&q=80",
  divider4: "https://images.unsplash.com/photo-1560448204-603b3fc33ddc?w=1800&q=80",
  divider5: "https://images.unsplash.com/photo-1448630360428-65456885c650?w=1800&q=80",
};

// ─── EXCLUSIVE IMAGES (using Unsplash) ──────────────────────────────────
const EXCLUSIVE_IMAGES = {
  "Luxury Bay Residences": "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=800&q=80",
  "Elite Waterfront": "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800&q=80",
  "The Royals": "https://images.unsplash.com/photo-1600566752355-35792bedcfea?w=800&q=80",
  "Palm Springs": "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?w=800&q=80",
  "Gardenia Luxury": "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800&q=80",
  "Waterfront Towers": "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800&q=80",
};

// ─── LOCALITY IMAGES (using Unsplash) ──────────────────────────────────
const LOCALITY_IMAGES = {
  "New Town": "https://images.unsplash.com/photo-1569336415962-a4bd9f69cd83?w=600&q=80",
  "Rajarhat": "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?w=600&q=80",
  "EM Bypass": "https://images.unsplash.com/photo-1574362848149-11496d93a7c7?w=600&q=80",
  "Ballygunge": "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&q=80",
  "Alipore": "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600&q=80",
  "Tollygunge": "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=600&q=80",
  "Salt Lake": "https://images.unsplash.com/photo-1560448204-603b3fc33ddc?w=600&q=80",
  "Kasba": "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=600&q=80",
  "Garia": "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=600&q=80",
  "Lake Town": "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=600&q=80",
  "Park Street": "https://images.unsplash.com/photo-1613977257363-707ba9348227?w=600&q=80",
  "Behala": "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=600&q=80",
  "Howrah": "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&q=80",
  "Newtown AA-I": "https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=600&q=80",
  "South Kolkata": "https://images.unsplash.com/photo-1536575695483-8ec8cdfbdccf?w=600&q=80",
  "Narayanpur": "https://images.unsplash.com/photo-1569336415962-a4bd9f69cd83?w=600&q=80",
  "Jatragachi": "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?w=600&q=80",
  "Action Area 2B": "https://images.unsplash.com/photo-1560448204-603b3fc33ddc?w=600&q=80",
};

const PROJECT_MEDIA = {
  // ─── PROPERTIES WITH LOCAL MEDIA ─────────────────────────────────────────
  "Sunrise Greens": {
    images: [sunriseb3, sunriseb4, sunriseb1, sunriseb2, sunriseb5, sunriseb8],
    video: SunriseGreens_images,
  },
  "Urban Vista": {
    images: [urbanvistaa3, urbanvistaa4, urbanvistaa5, urbanvistaa6, urbanvistaa8],
    video: urbar_vista_image,
  },
  "Priti Samabay Abasan Samiti": {
    images: [
      PritiSamabayAbasanSamiti1,
      PritiSamabayAbasanSamiti2,
      PritiSamabayAbasanSamiti3,
      PritiSamabayAbasanSamiti4,
      PritiSamabayAbasanSamiti5,
      PritiSamabayAbasanSamiti6,
      PritiSamabayAbasanSamiti7,
    ],
    video: PritiSamabayAbasanSamiti_vedio,
  },
  "Ideal Abasan - Block F": {
    images: [
      IdealAbasan_block_F1,
      IdealAbasan_block_F2,
      IdealAbasan_block_F3,
      IdealAbasan_block_F4,
      IdealAbasan_block_F6,
      IdealAbasan_block_F7,
      IdealAbasan_block_F8,
      IdealAbasan_block_F9,
      IdealAbasan_block_F11,
    ],
    video: "https://www.youtube.com/embed/dQw4w9WgXcQ",
  },
  "Ideal Abasan - Block C (Rent)": {
    images: [
      IdealAbasan_block_c10,
      IdealAbasan_block_c2,
      IdealAbasan_block_c3,
      IdealAbasan_block_c4,
      IdealAbasan_block_c5,
      IdealAbasan_block_c6,
      IdealAbasan_block_c7,
      IdealAbasan_block_c8,
      IdealAbasan_block_c9,
      IdealAbasan_block_c1,
      IdealAbasan_block_c11,
      IdealAbasan_block_c12,
      IdealAbasan_block_c13,
    ],
    video: IdealAbasan_vedio,
  },
  "Ideal Abasan - Block G": {
    images: [
      IdealAbasan_block_E1,
      IdealAbasan_block_E2,
      IdealAbasan_block_E3,
      IdealAbasan_block_E5,
      IdealAbasan_block_E6,
      IdealAbasan_block_E7,
      IdealAbasan_block_E8,
    ],
    video: IdealAbasan_block_E_vedio,
  },
  "Ideal Abasan - Block J": {
    images: [
      IdealAbasan_block_j7,
      IdealAbasan_block_j1,
      IdealAbasan_block_j2,
      IdealAbasan_block_j3,
      IdealAbasan_block_j4,
      IdealAbasan_block_j5,
      IdealAbasan_block_j6,
    ],
    video: IdealAbasan_block_j_vedio,
  },
  "Ideal Abasan - Block C (Sell)": {
    images: [
      IdealAbasan4E1,
      IdealAbasan4E2,
      IdealAbasan4E3,
      IdealAbasan4E4,
      IdealAbasan4E5,
      IdealAbasan4E6,
      IdealAbasan4E7,
      IdealAbasan4E8,
      IdealAbasan4E9,
    ],
    video: IdealAbasan4E_vedio,
  },
  "Pallab Pal & Dipak K. Sarkar": {
    images: [
      PallabPalDipaKSarkar7,
      PallabPalDipaKSarkar3,
      PallabPalDipaKSarkar1,
      PallabPalDipaKSarkar2,
      PallabPalDipaKSarkar4,
      PallabPalDipaKSarkar5,
      PallabPalDipaKSarkar8,
    ],
    video: PallabPalDipaKSarkar1Vedio,
  },

  // ─── NEW PROPERTY 22: INDIVIDUAL BUILDING (COMMERCIAL) ──────────────────
  "Individual Building - VIP Road": {
    images: [
      IndividualBuilding_image1,
      IndividualBuilding_image2,
      IndividualBuilding_image3,
      IndividualBuilding_image4,
      IndividualBuilding_image5,
    ],
    video: "",
  },

  // ─── NEW PROPERTY 23: NBCC VIBGYOR TOWER ──────────────────────────────
  "NBCC Vibgyor Tower": {
    images: [
      NBCCVibgyorTower_image2,
      NBCCVibgyorTower_image3,
      NBCCVibgyorTower_image4,
      NBCCVibgyorTower_image5,
    ],
    video: NBCCVibgyorTower_vedio,
  },

  // ─── NEW PROPERTY 24: URBAN VISTA PHASE 1 (3BHK) ──────────────────────
  "Urban Vista Phase 1": {
    images: [
      UrbanVistaPhase1_image1,
      UrbanVistaPhase1_image2,
      UrbanVistaPhase1_image3,
      UrbanVistaPhase1_image4,
      UrbanVistaPhase1_image5,
    ],
    video: UrbanVistaPhase1_vedio,
  },

  // ─── NEW PROPERTY 25: URBAN VISTA PHASE 1 - 2BHK ──────────────────────
  "Urban Vista Phase 1 - 2BHK": {
    images: [
      Reckjoani_image1,
      Reckjoani_image2,
      Reckjoani_image3,
      Reckjoani_image5,
      Reckjoani_image6,
      Reckjoani_image7,
      Reckjoani_image8,
      Reckjoani_image9,
      Reckjoani_image10
    ],
    video: "",
  },
};

// ─── DATA - All Properties ──────────────────────────────────────────────────
const PROJECTS = [
  // ============================================
  // RESIDENTIAL PROPERTIES (13-21) - EXISTING
  // ============================================
  {
    id: 13,
    name: "Pallab Pal & Dipak K. Sarkar",
    location: "Action Area 2D, New Town",
    price: "₹77 Lac",
    bhk: "3 BHK",
    developer: "Pallab Pal & Dipak K. Sarkar",
    badge: "BUILDER SELL",
    type: "Sell",
    category: "Residential",
    details: {
      furnishing: "Unfurnished",
      floor: "1st, 3rd and 4th Floor (G+4)",
      area: "1050 Sq. Ft. Carpet Area",
      parking: "1 Car Parking",
      contactPerson: "Sumit Patra",
      mobile: "8981768292",
      source: "Via Caretaker",
      remarks: [
        "Visit possible on any day with one day's prior information.",
        "Give some commission to Sumit Patra after deal done",
      ],
    },
  },
  {
    id: 14,
    name: "Sunrise Greens",
    location: "Jatragachi, New Town",
    price: "₹1.25 Cr",
    bhk: "3 BHK",
    developer: "Sunrise Group",
    badge: "PREMIUM SELL",
    type: "Sell",
    category: "Residential",
    details: {
      furnishing: "Unfurnished",
      floor: "10th Floor (G+16)",
      area: "1535 Sq. Ft. Super Built-Up",
      parking: "1 Basement Car Parking",
      contactPerson: "Sumit Patra",
      mobile: "8981768292",
      source: "Via Broker",
      remarks: [
        "Visit possible on any day with one day's prior information.",
        "Kanwaljit takes 2% brokerage from the owner side.",
      ],
    },
  },
  {
    id: 15,
    name: "Urban Vista",
    location: "Rajarhat Main Road",
    price: "₹20,000/Month",
    bhk: "2 BHK",
    developer: "New Way Real Estate",
    badge: "RENT",
    type: "Rent",
    category: "Residential",
    details: {
      furnishing: "Unfurnished",
      floor: "Middle Floor (G+10)",
      area: "900 Sq. Ft. Super Built-Up (Approx.)",
      parking: "1 Covered Car Parking",
      contactPerson: "Sumit Patra",
      mobile: "8981768292",
      source: "Via Broker",
      remarks: [
        "Visit possible on any day with one day's prior information.",
        "Kanwaljit takes 1 Months brokerage from the owner side.",
        "Preferred Hindu Family with Job.",
      ],
    },
  },
  {
    id: 16,
    name: "Priti Samabay Abasan Samiti",
    location: "Action Area 2B, New Town",
    price: "₹35,000/Month",
    bhk: "3 BHK",
    developer: "Priti Samabay",
    badge: "RENT",
    type: "Rent",
    category: "Residential",
    details: {
      furnishing: "Semi-Furnished",
      floor: "Not Specified (G+4)",
      area: "1200 Sq. Ft. Super Built-Up (Approx.)",
      parking: "1 Car Parking",
      contactPerson: "Spandan Biswas (Broker)",
      contactPerson: "Sumit Patra",
      mobile: "8981768292",
      remarks: [
        "Call one day before scheduling a visit.",
        "Spandan takes brokerage from the owner side.",
        "Property is available for rent.",
      ],
    },
  },
  {
    id: 17,
    name: "Ideal Abasan - Block F",
    location: "Narayanpur, Rajarhat",
    price: "₹16,000/Month",
    bhk: "2 BHK",
    developer: "Ideal Group",
    badge: "RENT",
    type: "Rent",
    category: "Residential",
    details: {
      furnishing: "Semi-Furnished",
      floor: "4th Floor (G+5)",
      area: "860 Sq. Ft. Super Built-Up",
      parking: "1 Open Car Parking",
      contactPerson: "Sumit Patra",
      mobile: "8981768292",
      source: "Via Facility Manager",
      remarks: [
        "Any day visit possible except Thursday.",
        "Call the Facility Manager one day before scheduling a visit.",
        "Facility Manager takes 1 Month Rent brokerage from the owner side.",
        "Preferred Hindu family with job profile as tenants.",
      ],
    },
  },
  {
    id: 18,
    name: "Ideal Abasan - Block C (Rent)",
    location: "Narayanpur, Rajarhat",
    price: "₹18,000/Month",
    bhk: "3 BHK",
    developer: "Ideal Group",
    badge: "RENT",
    type: "Rent",
    category: "Residential",
    details: {
      furnishing: "Unfurnished",
      floor: "4th Floor (G+5)",
      area: "1100 Sq. Ft. Super Built-Up",
      parking: "1 Car Parking",
      contactPerson: "Sumit Patra",
      mobile: "8981768292",
      source: "Via Facility Manager",
      remarks: [
        "Any day visit possible except Thursday.",
        "Call the Facility Manager one day before scheduling a visit.",
        "Facility Manager takes 1 Month Rent brokerage from the owner side.",
      ],
    },
  },
  {
    id: 19,
    name: "Ideal Abasan - Block G",
    location: "Narayanpur, Rajarhat",
    price: "₹62 Lac",
    bhk: "3 BHK",
    developer: "Ideal Group",
    badge: "SELL",
    type: "Sell",
    category: "Residential",
    details: {
      furnishing: "Furnished",
      floor: "5th Floor (G+5)",
      area: "1100 Sq. Ft. Super Built-Up",
      parking: "1 Car Parking",
      contactPerson: "Sumit Patra",
      mobile: "8981768292",
      source: "Via Facility Manager",
      remarks: [
        "Any day visit possible except Thursday.",
        "Call the Facility Manager one day before scheduling a visit.",
        "Facility Manager takes 2% Rent brokerage from the owner side.",
      ],
    },
  },
  {
    id: 20,
    name: "Ideal Abasan - Block J",
    location: "Narayanpur, Rajarhat",
    price: "₹40 Lac",
    bhk: "2 BHK",
    developer: "Ideal Group",
    badge: "SELL",
    type: "Sell",
    category: "Residential",
    details: {
      furnishing: "Unfurnished",
      floor: "3rd Floor (G+5)",
      area: "860 Sq. Ft. Super Built-Up",
      parking: "1 Car Parking",
      contactPerson: "Sumit Patra",
      mobile: "8981768292",
      source: "Via Facility Manager",
      remarks: [
        "Any day visit possible except Thursday.",
        "Call the Facility Manager one day before scheduling a visit.",
        "Facility Manager takes 2% brokerage from the owner side.",
      ],
    },
  },
  {
    id: 21,
    name: "Ideal Abasan - Block C (Sell)",
    location: "Narayanpur, Rajarhat",
    price: "₹62 Lac",
    bhk: "3 BHK",
    developer: "Ideal Group",
    badge: "SELL",
    type: "Sell",
    category: "Residential",
    details: {
      furnishing: "Unfurnished",
      floor: "4th Floor (G+5)",
      area: "1100 Sq. Ft. Super Built-Up",
      parking: "1 Car Parking",
      contactPerson: "Sumit Patra",
      mobile: "8981768292",
      source: "Via Facility Manager",
      remarks: [
        "Any day visit possible except Thursday.",
        "Call the Facility Manager one day before scheduling a visit.",
        "Facility Manager takes 2% brokerage from the owner side.",
      ],
    },
  },

  // ============================================
  // NEW PROPERTY 22: COMMERCIAL OFFICE - TEGHORIA
  // ============================================
  {
    id: 22,
    name: "Individual Building - VIP Road",
    location: "Teghoria, VIP Main Road (Near M Bazar)",
    price: "₹3.3 Cr",
    bhk: "Commercial Office",
    developer: "Individual Builder",
    badge: "COMMERCIAL SELL",
    type: "Sell",
    category: "Commercial",
    details: {
      furnishing: "Semi-furnished",
      floor: "4th Floor (G+6)",
      area: "3000 Sq. Ft.",
      parking: "Not Specified",
      pricePerSqft: "₹11,000/Sq. Ft.",
      contactPerson: "Sumit Patra",
      mobile: "8981768292",
      source: "Via Broker",
      brokerage: "2% (Buyer Side)",
      remarks: [
        "Visit possible on any day with one day's prior information.",
        "Unit can be divided into 2 parts (1,500 sqft + 1,500 sqft)",
        "Sukhendu took owner side brokerage",
        "Can be used as Café or showroom purpose.",
        "For Site Visit or More Details, contact Next Front Properties.",
      ],
    },
  },

  // ============================================
  // NEW PROPERTY 23: RESIDENTIAL FLAT - NEW TOWN
  // ============================================
  {
    id: 23,
    name: "NBCC Vibgyor Tower",
    location: "Action Area 1, New Town",
    price: "₹1.05 Cr",
    bhk: "3 BHK + 2 Toilets + 1 Balcony + 1 Servant Room",
    developer: "NBCC",
    badge: "PREMIUM SELL",
    type: "Sell",
    category: "Residential",
    details: {
      furnishing: "Unfurnished",
      floor: "8th Floor (G+15)",
      area: "1578 Sq. Ft. Super Built Up Area",
      parking: "1 Open Car Parking",
      contactPerson: "Sumit Patra",
      mobile: "8981768292",
      source: "Via Broker (Call via Sumit Patra Reference)",
      brokerage: "2% (Buyer Side)",
      remarks: [
        "Visit possible on any day with one day's prior information.",
        "Kanwaljit took 2% brokerage from the owner.",
        "For Site Visit or More Details, contact Next Front Properties.",
      ],
    },
  },

  // ============================================
  // NEW PROPERTY 24: RESIDENTIAL FLAT - RECKJOANI (3 BHK)
  // ============================================
  {
    id: 24,
    name: "Urban Vista Phase 1",
    location: "Reckjoani, Rajarhat Main Road",
    price: "₹80 Lacs",
    bhk: "3 BHK + 2 Toilets + 1 Balcony",
    developer: "Urban Vista",
    badge: "SELL",
    type: "Sell",
    category: "Residential",
    details: {
      furnishing: "Unfurnished",
      floor: "4th Floor (G+14)",
      area: "1134 Sq. Ft. Super Built Up Area",
      parking: "1 Multi Level Car Parking",
      contactPerson: "Sumit Patra",
      mobile: "8981768292",
      source: "Direct Owner",
      brokerage: "2%",
      remarks: [
        "Visit possible on any day with one day's prior information.",
        "For Site Visit or More Details, contact Next Front Properties.",
      ],
    },
  },

  // ============================================
  // NEW PROPERTY 25: RESIDENTIAL FLAT - RECKJOANI (2 BHK)
  // ─── ADDED BASED ON USER INPUT ──────────────────
  // ============================================
  {
    id: 25,
    name: "Urban Vista Phase 1 - 2BHK",
    location: "Reckjoani, Rajarhat Main Road",
    price: "₹77 Lacs",
    bhk: "2 BHK + 2 Toilets + 1 Balcony",
    developer: "Urban Vista",
    badge: "SELL",
    type: "Sell",
    category: "Residential",
    details: {
      furnishing: "Unfurnished",
      floor: "8th Floor (G+14)",
      area: "681 Sq. Ft. Built Up Area",
      parking: "1 Covered Car Parking",
      facing: "North",
      contactPerson: "Sumit Patra",
      mobile: "8981768292",
      brokerage: "2%",
      remarks: [
        "Visit possible with one day's prior information.",
        "For Site Visit or More Details, contact Next Front Properties.",
      ],
    },
  },
];

const EXCLUSIVE = [
  {
    id: 101,
    name: "Luxury Bay Residences",
    location: "New Town Action Area I",
    price: "₹1.25 Cr",
    bhk: "3, 4 BHK",
  },
  {
    id: 102,
    name: "Elite Waterfront",
    location: "Rajarhat, Near Biswa Bangla Gate",
    price: "₹1.15 Cr",
    bhk: "3, 4 BHK",
  },
  {
    id: 103,
    name: "The Royals",
    location: "Alipore",
    price: "₹2.1 Cr",
    bhk: "4, 5 BHK",
  },
  {
    id: 104,
    name: "Palm Springs",
    location: "Salt Lake City",
    price: "₹98 Lac",
    bhk: "3 BHK",
  },
  {
    id: 105,
    name: "Gardenia Luxury",
    location: "EM Bypass",
    price: "₹1.05 Cr",
    bhk: "3, 4 BHK",
  },
  {
    id: 106,
    name: "Waterfront Towers",
    location: "New Town",
    price: "₹1.1 Cr",
    bhk: "3, 4 BHK",
  },
];

const TESTIMONIALS = [
  {
    name: "Sudipta Hazra",
    initials: "SH",
    text: "Dealing with NextFrontProperties has been a very pleasurable experience. They helped me purchase a 3BHK at Sunrise Residency and guided me through the entire process with transparency and care.",
  },
  {
    name: "Sharmila Chopra",
    initials: "SC",
    text: "The team is very well-mannered and professional. They helped us finalise our home deal at Green Valley Heights and were by our side through every step of the execution process.",
  },
  {
    name: "Sangeeta Kathait",
    initials: "SK",
    text: "They helped convert our dream into reality — a lovely flat in New Alipore at Lake View Apartments. Without their help and expert negotiation, this dream wouldn't have been possible.",
  },
  {
    name: "Dr. Abhijit Sarkar",
    initials: "AS",
    text: "NextFrontProperties are polite, approachable, and absolutely transparent in their behaviour. They made my property search at City Lights Towers stress-free and enjoyable.",
  },
];

const STATS = [
  { value: "35+", label: "Years of Excellence" },
  { value: "500+", label: "Projects Marketed" },
  { value: "350L+", label: "Sq. Ft. Transacted" },
  { value: "2500+", label: "Happy Families" },
];

const LOCALITIES = [
  { id: 201, name: "New Town", count: "120+ properties" },
  { id: 202, name: "Rajarhat", count: "95+ properties" },
  { id: 203, name: "EM Bypass", count: "75+ properties" },
  { id: 204, name: "Ballygunge", count: "55+ properties" },
  { id: 205, name: "Alipore", count: "45+ properties" },
  { id: 206, name: "Tollygunge", count: "65+ properties" },
  { id: 207, name: "Salt Lake", count: "85+ properties" },
  { id: 208, name: "Kasba", count: "40+ properties" },
  { id: 209, name: "Garia", count: "35+ properties" },
  { id: 210, name: "Lake Town", count: "50+ properties" },
  { id: 211, name: "Park Street", count: "25+ properties" },
  { id: 212, name: "Behala", count: "45+ properties" },
  { id: 213, name: "Howrah", count: "35+ properties" },
  { id: 214, name: "Newtown AA-I", count: "60+ properties" },
  { id: 215, name: "South Kolkata", count: "70+ properties" },
  { id: 216, name: "Narayanpur", count: "25+ properties" },
  { id: 217, name: "Jatragachi", count: "15+ properties" },
  { id: 218, name: "Action Area 2B", count: "20+ properties" },
];

const DEVELOPERS = [
  { name: "Ambuja Neotia", initials: "AN" },
  { name: "Merlin Group", initials: "MG" },
  { name: "Godrej Properties", initials: "GP" },
  { name: "Eden Group", initials: "EG" },
  { name: "SKDJ Group", initials: "SK" },
  { name: "Srijan Group", initials: "SR" },
  { name: "Shapoorji Pallonji", initials: "SP" },
  { name: "Tata Housing", initials: "TH" },
  { name: "PS Group", initials: "PS" },
  { name: "Shrachi Group", initials: "SH" },
  { name: "Natural Group", initials: "NG" },
  { name: "Emami Realty", initials: "EM" },
  { name: "Ideal Group", initials: "IG" },
];

const TABS = ["Residential", "Commercial", "Land", "Investment"];

// ─── EMAILJS CONFIGURATION ──────────────────────────────────────────────────
const EMAILJS_CONFIG = {
  SERVICE_ID: "service_somu38y",
  TEMPLATE_ID: "template_jvsn8tq",
  PUBLIC_KEY: "nbgiKhgvRrvIMJUfQ",
};

// ─── SVG ICONS ────────────────────────────────────────────────────────────────
const IconPin = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const IconSearch = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.35-4.35" />
  </svg>
);

const IconArrow = ({ dir = "right", size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    style={{ transform: dir === "left" ? "rotate(180deg)" : "none", flexShrink: 0 }}>
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

const IconPhone = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.6 3.53 2 2 0 0 1 3.56 1.35h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 16.92z" />
  </svg>
);

const IconWhatsapp = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
    <path d="M12 0C5.373 0 0 5.373 0 12c0 2.124.558 4.115 1.528 5.845L.057 23.926l6.234-1.635A11.945 11.945 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.885 0-3.64-.52-5.146-1.422l-.369-.217-3.813 1 1.018-3.716-.24-.38A9.96 9.96 0 0 1 2 12C2 6.486 6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z" />
  </svg>
);

const IconStar = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="#C9A84C" stroke="#C9A84C" strokeWidth="1">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const IconClose = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 6L6 18M6 6l12 12" />
  </svg>
);

// ─── ANIMATED SECTION COMPONENT ─────────────────────────────────────────────
const AnimatedSection = ({ children, delay = 0, className = "" }) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setIsVisible(true);
          }, delay * 1000);
          observer.disconnect();
        }
      },
      { threshold: 0.1, rootMargin: "50px" }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [delay]);

  return (
    <div ref={sectionRef} className={`animated-section ${isVisible ? "visible" : ""} ${className}`}>
      {children}
    </div>
  );
};

// ─── BACKGROUND SECTION COMPONENT ───────────────────────────────────────────
const BgSection = ({ children, bgImage, id }) => {
  return (
    <div
      id={id}
      style={{
        position: "relative",
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "linear-gradient(135deg, rgba(7,16,30,0.88) 0%, rgba(13,26,45,0.85) 50%, rgba(7,16,30,0.88) 100%)",
          zIndex: 1,
        }}
      />
      <div style={{ position: "relative", zIndex: 2 }}>{children}</div>
    </div>
  );
};

// ─── DIVIDER SECTION COMPONENT ─────────────────────────────────────────────
const DividerSection = ({ bgImage, title, subtitle, delay = 0, onExplore }) => {
  return (
    <AnimatedSection delay={delay}>
      <div className="ke-divider-section">
        <div className="ke-divider-bg" style={{ backgroundImage: `url(${bgImage})` }} />
        <div className="ke-divider-overlay"></div>
        <div className="ke-divider-content">
          <h2 className="ke-divider-title">{title}</h2>
          <p className="ke-divider-subtitle">{subtitle}</p>
          <button className="ke-btn-gold ke-divider-btn" onClick={onExplore}>
            Explore Now <IconArrow />
          </button>
        </div>
      </div>
    </AnimatedSection>
  );
};

// ─── PROJECT CARD ────────────────────────────────────────────────────────────
const ProjectCard = ({ project, delay = 0, onViewDetails }) => {
  const media = PROJECT_MEDIA[project.name] || {
    images: [DEFAULT_IMAGE],
  };
  const projectImage = media.images[0] || DEFAULT_IMAGE;
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setIsVisible(true);
          }, delay * 1000);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => observer.disconnect();
  }, [delay]);

  return (
    <div
      ref={cardRef}
      className={`ke-proj-card ${isVisible ? "card-visible" : ""}`}
      onClick={() => onViewDetails && onViewDetails(project)}
    >
      <div className="ke-proj-image-wrapper">
        <img src={projectImage} alt={project.name} className="ke-proj-image" />
        {project.badge && <div className="ke-proj-badge">{project.badge}</div>}
        {project.type && (
          <div style={{
            position: "absolute",
            top: "12px",
            right: "12px",
            background: project.type === "Rent" ? "#25D366" : "#C9A84C",
            color: "#07101e",
            padding: "3px 8px",
            borderRadius: "3px",
            fontSize: "7px",
            fontWeight: "700",
            letterSpacing: "1px",
            textTransform: "uppercase",
            zIndex: 2,
          }}>
            {project.type}
          </div>
        )}
        {media.images && media.images.length > 1 && (
          <div style={{
            position: "absolute",
            bottom: "8px",
            right: "8px",
            background: "rgba(0,0,0,0.6)",
            color: "#fff",
            padding: "2px 8px",
            borderRadius: "10px",
            fontSize: "9px",
            zIndex: 2,
          }}>
            📷 {media.images.length}
          </div>
        )}
        {media.video && (
          <div style={{
            position: "absolute",
            bottom: "8px",
            left: "8px",
            background: "rgba(255,0,0,0.7)",
            color: "#fff",
            padding: "2px 8px",
            borderRadius: "10px",
            fontSize: "9px",
            zIndex: 2,
          }}>
            ▶️ Video
          </div>
        )}
      </div>
      <div className="ke-proj-content">
        <h3 className="ke-proj-name">{project.name}</h3>
        <div className="ke-proj-loc"><IconPin /> {project.location}</div>
        <div className="ke-proj-price">{project.price}</div>
        <div className="ke-proj-meta">{project.bhk}</div>
        <div className="ke-proj-link" onClick={(e) => { e.stopPropagation(); onViewDetails && onViewDetails(project); }}>
          View Details <IconArrow size={11} />
        </div>
      </div>
    </div>
  );
};

// ─── EXCLUSIVE CARD ──────────────────────────────────────────────────────────
const ExclusiveCard = ({ item, delay = 0, onViewDetails }) => {
  const itemImage = EXCLUSIVE_IMAGES[item.name] || DEFAULT_IMAGE;
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setIsVisible(true);
          }, delay * 1000);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => observer.disconnect();
  }, [delay]);

  return (
    <div
      ref={cardRef}
      className={`ke-excl-card ${isVisible ? "card-visible" : ""}`}
      onClick={() => onViewDetails && onViewDetails(item)}
    >
      <div className="ke-excl-image-wrapper">
        <img src={itemImage} alt={item.name} className="ke-excl-image" />
        <div className="ke-excl-badge">Exclusive</div>
      </div>
      <div className="ke-excl-content">
        <h3 className="ke-excl-name">{item.name}</h3>
        <div className="ke-excl-loc"><IconPin /> {item.location}</div>
        <div className="ke-excl-price">{item.price}</div>
        <div className="ke-excl-bhk">{item.bhk}</div>
      </div>
    </div>
  );
};

// ─── LOCALITY CARD ──────────────────────────────────────────────────────────
const LocalityCard = ({ locality, delay = 0, onSelect }) => {
  const localityImage = LOCALITY_IMAGES[locality.name] || DEFAULT_IMAGE;
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setIsVisible(true);
          }, delay * 1000);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => observer.disconnect();
  }, [delay]);

  return (
    <div
      ref={cardRef}
      className={`ke-loc-card ${isVisible ? "card-visible" : ""}`}
      onClick={() => onSelect && onSelect(locality)}
    >
      <div className="ke-loc-image-wrapper">
        <img src={localityImage} alt={locality.name} className="ke-loc-image" />
        <div className="ke-loc-overlay"></div>
        <div className="ke-loc-content">
          <div className="ke-loc-name">{locality.name}</div>
          <div className="ke-loc-count">{locality.count}</div>
        </div>
      </div>
    </div>
  );
};

// ─── PROJECT POPUP WITH IMAGES + VIDEO ─────────────────────────────────────
const ProjectPopup = ({ project, onClose, phoneDisplay }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showVideo, setShowVideo] = useState(false);
  const [videoError, setVideoError] = useState(false);

  const media = PROJECT_MEDIA[project?.name] || {
    images: [DEFAULT_IMAGE],
    video: null,
  };
  const images = media.images || [];
  const videoUrl = media.video || null;

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  const handleCall = () => {
    window.location.href = "tel:+918584826222";
  };

  const handleWhatsApp = () => {
    window.open("https://wa.me/918584826222", "_blank");
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const toggleVideo = () => {
    setShowVideo(!showVideo);
    setVideoError(false);
  };

  const isYouTubeEmbed = (url) => {
    if (!url) return false;
    return url.includes('youtube.com/embed') || url.includes('youtu.be');
  };

  const isMP4File = (url) => {
    if (!url) return false;
    return typeof url === 'string' && (url.endsWith('.mp4') || url.includes('.mp4'));
  };

  const renderVideo = () => {
    if (!videoUrl || videoError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          background: '#0a0a0a',
          color: '#666',
          padding: '20px',
          textAlign: 'center'
        }}>
          <span style={{ fontSize: '48px', marginBottom: '16px' }}>🎬</span>
          <p style={{ fontSize: '14px', color: '#999' }}>
            {videoError ? 'Video unavailable' : 'No video available'}
          </p>
          <button
            onClick={() => {
              setVideoError(false);
              setShowVideo(false);
            }}
            style={{
              marginTop: '12px',
              padding: '8px 20px',
              background: 'var(--gold)',
              border: 'none',
              borderRadius: '6px',
              color: '#07101e',
              fontWeight: 600,
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            Back to Photos
          </button>
        </div>
      );
    }

    if (isYouTubeEmbed(videoUrl)) {
      return (
        <iframe
          src={videoUrl}
          title={`${project.name} Video`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="ke-popup-video"
          onError={() => setVideoError(true)}
        />
      );
    }

    if (isMP4File(videoUrl)) {
      return (
        <video
          src={videoUrl}
          controls
          autoPlay
          className="ke-popup-video"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          onError={() => setVideoError(true)}
          playsInline
        />
      );
    }

    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        background: '#0a0a0a',
        color: '#666',
        padding: '20px',
        textAlign: 'center'
      }}>
        <span style={{ fontSize: '48px', marginBottom: '16px' }}>🎬</span>
        <p style={{ fontSize: '14px', color: '#999' }}>Video format not supported</p>
        <button
          onClick={() => setShowVideo(false)}
          style={{
            marginTop: '12px',
            padding: '8px 20px',
            background: 'var(--gold)',
            border: 'none',
            borderRadius: '6px',
            color: '#07101e',
            fontWeight: 600,
            cursor: 'pointer',
            fontSize: '12px'
          }}
        >
          Back to Photos
        </button>
      </div>
    );
  };

  if (!project) return null;

  const details = project.details || {};

  return (
    <div className="ke-popup-overlay" onClick={onClose}>
      <div className="ke-popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="ke-popup-close" onClick={onClose}>
          <IconClose />
        </button>
        <div className="ke-popup-image-wrapper">
          {!showVideo ? (
            <>
              <img
                src={images[currentImageIndex] || DEFAULT_IMAGE}
                alt={project.name}
                className="ke-popup-image"
              />
              {images.length > 1 && (
                <>
                  <button className="ke-popup-nav-btn ke-popup-nav-prev" onClick={(e) => { e.stopPropagation(); prevImage(); }}>
                    ‹
                  </button>
                  <button className="ke-popup-nav-btn ke-popup-nav-next" onClick={(e) => { e.stopPropagation(); nextImage(); }}>
                    ›
                  </button>
                  <div className="ke-popup-dots">
                    {images.map((_, idx) => (
                      <span
                        key={idx}
                        className={`ke-popup-dot ${idx === currentImageIndex ? "active" : ""}`}
                        onClick={(e) => { e.stopPropagation(); setCurrentImageIndex(idx); }}
                      />
                    ))}
                  </div>
                </>
              )}
            </>
          ) : (
            <div className="ke-popup-video-container">
              {renderVideo()}
              <button className="ke-popup-close-video" onClick={toggleVideo}>
                ✕
              </button>
            </div>
          )}

          {project.badge && <div className="ke-popup-badge">{project.badge}</div>}
          {project.type && (
            <div style={{
              position: "absolute",
              top: "16px",
              right: "16px",
              background: project.type === "Rent" ? "#25D366" : "#C9A84C",
              color: "#07101e",
              padding: "4px 12px",
              borderRadius: "4px",
              fontSize: "10px",
              fontWeight: "700",
              letterSpacing: "1.5px",
              textTransform: "uppercase",
              zIndex: 2,
            }}>
              {project.type}
            </div>
          )}

          <div className="ke-popup-media-controls">
            {videoUrl && !videoError && (
              <button
                className={`ke-popup-media-btn ${showVideo ? "active" : ""}`}
                onClick={(e) => { e.stopPropagation(); toggleVideo(); }}
              >
                {showVideo ? "📷 Photos" : "▶️ Video"}
              </button>
            )}
            {images.length > 1 && !showVideo && (
              <span className="ke-popup-image-counter">
                {currentImageIndex + 1} / {images.length}
              </span>
            )}
          </div>
        </div>

        <div className="ke-popup-body">
          <h2 className="ke-popup-title">{project.name}</h2>
          <div className="ke-popup-location"><IconPin /> {project.location}</div>
          <div className="ke-popup-price">{project.price}</div>

          <div className="ke-popup-details">
            <div className="ke-popup-detail-item">
              <span className="ke-popup-detail-label">Property Type</span>
              <span className="ke-popup-detail-value">{project.bhk}</span>
            </div>
            <div className="ke-popup-detail-item">
              <span className="ke-popup-detail-label">Developer</span>
              <span className="ke-popup-detail-value">{project.developer}</span>
            </div>
            {details.furnishing && (
              <div className="ke-popup-detail-item">
                <span className="ke-popup-detail-label">Furnishing</span>
                <span className="ke-popup-detail-value">{details.furnishing}</span>
              </div>
            )}
            {details.floor && (
              <div className="ke-popup-detail-item">
                <span className="ke-popup-detail-label">Floor</span>
                <span className="ke-popup-detail-value">{details.floor}</span>
              </div>
            )}
            {details.area && (
              <div className="ke-popup-detail-item">
                <span className="ke-popup-detail-label">Area</span>
                <span className="ke-popup-detail-value">{details.area}</span>
              </div>
            )}
            {details.parking && (
              <div className="ke-popup-detail-item">
                <span className="ke-popup-detail-label">Parking</span>
                <span className="ke-popup-detail-value">{details.parking}</span>
              </div>
            )}
            {details.facing && (
              <div className="ke-popup-detail-item">
                <span className="ke-popup-detail-label">Facing</span>
                <span className="ke-popup-detail-value">{details.facing}</span>
              </div>
            )}
          </div>

          {details.remarks && details.remarks.length > 0 && (
            <div style={{
              marginBottom: "16px",
              padding: "12px 16px",
              background: "rgba(255,255,255,0.04)",
              borderRadius: "8px",
              border: "1px solid rgba(255,255,255,0.06)",
            }}>
              <p style={{ fontSize: "11px", fontWeight: 600, color: "var(--text3)", textTransform: "uppercase", letterSpacing: "1px", marginBottom: "6px" }}>
                Remarks
              </p>
              {details.remarks.map((remark, index) => (
                <p key={index} style={{ fontSize: "12px", color: "var(--text2)", marginBottom: "4px" }}>
                  {index + 1}. {remark}
                </p>
              ))}
            </div>
          )}

          {details.mobile && (
            <div style={{
              marginBottom: "16px",
              padding: "8px 12px",
              background: "rgba(201,168,76,0.08)",
              borderRadius: "6px",
              border: "1px solid var(--border)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
              <span style={{ fontSize: "12px", color: "var(--text3)" }}>
                Contact: {details.contactPerson || "Property Owner"}
              </span>
              <a href={`tel:${details.mobile}`} style={{ color: "var(--gold)", fontSize: "13px", fontWeight: 600, textDecoration: "none" }}>
                {details.mobile}
              </a>
            </div>
          )}

          <div className="ke-popup-actions">
            <button className="ke-popup-btn-call" onClick={handleCall}>
              <IconPhone /> Call Now
            </button>
            <button className="ke-popup-btn-whatsapp" onClick={handleWhatsApp}>
              <IconWhatsapp /> WhatsApp
            </button>
          </div>
          <p className="ke-popup-contact">📞 {phoneDisplay}</p>
        </div>
      </div>
    </div>
  );
};

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────
export default function KolkataEstates() {
  const PHONE_NUMBER = "+918584826222";
  const PHONE_DISPLAY = "+91 85848 26222";

  const [activeTab, setActiveTab] = useState("Residential");
  const [testimonialIdx, setTestimonialIdx] = useState(0);
  const [visibleStats, setVisibleStats] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [navScrolled, setNavScrolled] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedLocality, setSelectedLocality] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [contactStep, setContactStep] = useState(1);
  const [contactInterest, setContactInterest] = useState("");
  const [contactBeds, setContactBeds] = useState("");
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [toast, setToast] = useState("");
  const [showAllProjects, setShowAllProjects] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
    locality: "",
    budget: "",
  });
  const statsRef = useRef(null);

  useEffect(() => {
    emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY);
  }, []);

  useEffect(() => {
    const onScroll = () => setNavScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setVisibleStats(true); },
      { threshold: 0.3 }
    );
    if (statsRef.current) obs.observe(statsRef.current);
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    const t = setInterval(() => setTestimonialIdx((i) => (i + 1) % TESTIMONIALS.length), 5000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && isPopupOpen) {
        setIsPopupOpen(false);
        setSelectedProject(null);
      }
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isPopupOpen]);

  const scrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName?.trim()) newErrors.firstName = "First name is required";
    if (!formData.lastName?.trim()) newErrors.lastName = "Last name is required";
    if (!formData.email?.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^[\+]?[1-9][\d]{0,15}$/.test(formData.phone.replace(/\D/g, ""))) {
      newErrors.phone = "Please enter a valid phone number";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmitContact = async () => {
    if (!validateForm()) {
      setToast("❌ Please fill in all required fields");
      setTimeout(() => setToast(""), 2800);
      return;
    }

    setIsSubmitting(true);

    try {
      const templateParams = {
        interest: contactInterest || "General Inquiry",
        from_name: `${formData.firstName} ${formData.lastName}`.trim(),
        from_email: formData.email.trim(),
        from_phone: formData.phone.trim(),
        bedrooms: contactBeds || "Not specified",
        message: formData.message?.trim() || "No additional message provided",
        date: new Date().toLocaleString("en-IN", {
          timeZone: "Asia/Kolkata",
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }),
      };

      const response = await emailjs.send(
        EMAILJS_CONFIG.SERVICE_ID,
        EMAILJS_CONFIG.TEMPLATE_ID,
        templateParams,
        EMAILJS_CONFIG.PUBLIC_KEY
      );

      console.log("EmailJS success:", response);
      setSubmitted(true);
      setToast("✅ Thank you! Your request has been submitted successfully.");

      setTimeout(() => {
        setFormData({ firstName: "", lastName: "", email: "", phone: "", message: "", locality: "", budget: "" });
        setErrors({});
        setContactStep(1);
        setContactInterest("");
        setContactBeds("");
        setContactModalOpen(false);
        setSubmitted(false);
        setTimeout(() => setToast(""), 2000);
      }, 1500);
    } catch (error) {
      console.error("EmailJS error:", error);
      setIsSubmitting(false);

      const useMailto = window.confirm(
        "❌ Email service is temporarily unavailable.\n\n" +
        "Would you like to send your inquiry directly via your email app instead?\n\n" +
        "✓ Click OK to open your email app with all details pre-filled\n" +
        "✓ Click Cancel to close and try again later"
      );

      if (useMailto) {
        const subject = `Property Inquiry: ${contactInterest || "New Inquiry"} - ${formData.firstName} ${formData.lastName}`;
        const body = `
NEXT.FRONT PROPERTIES - NEW INQUIRY
====================================
Interest: ${contactInterest || "General Inquiry"}
Bedrooms: ${contactBeds || "Not specified"}

CONTACT DETAILS
------------------------------------
Name: ${formData.firstName} ${formData.lastName}
Email: ${formData.email}
Phone: ${formData.phone}

MESSAGE
------------------------------------
${formData.message || "No message provided"}

Submitted: ${new Date().toLocaleString()}
        `.trim();
        window.location.href = `mailto:info@nextfrontproperties.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        setToast("📧 Opening your email app...");
        setTimeout(() => setToast(""), 2800);
        setContactModalOpen(false);
      } else {
        setToast("❌ Submission cancelled. Please try again later.");
        setTimeout(() => setToast(""), 2800);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const openContactModal = (interest, propertyName = "") => {
    setContactInterest(propertyName ? `${interest} - ${propertyName}` : interest);
    setContactStep(3);
    setContactModalOpen(true);
    document.body.style.overflow = "hidden";
    setSubmitted(false);
    setErrors({});
  };

  const closeContactModal = () => {
    setContactModalOpen(false);
    document.body.style.overflow = "unset";
    setTimeout(() => {
      if (!submitted) {
        setFormData({ firstName: "", lastName: "", email: "", phone: "", message: "", locality: "", budget: "" });
        setErrors({});
        setContactStep(1);
        setContactInterest("");
        setContactBeds("");
      }
    }, 400);
  };

  const handleInterestSelect = (value) => {
    setContactInterest(value);
    setContactStep(2);
  };

  const handleBedSelect = (value) => {
    setContactBeds(value);
    setContactStep(3);
  };

  const handleProjectView = (project) => {
    setSelectedProject(project);
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setSelectedProject(null);
  };

  const handleLocalitySelect = (locality) => {
    setSelectedLocality(locality);
    scrollTo("projects");
    setSearchQuery(locality.name);
  };

  const handleExploreNow = () => {
    scrollTo("projects");
  };

  const handleViewAllProjects = () => {
    setShowAllProjects(true);
    scrollTo("projects");
  };

  const handleShowLess = () => {
    setShowAllProjects(false);
    scrollTo("projects");
  };

  const handleTalkToExpert = () => {
    openContactModal("Expert Consultation");
  };

  const handleScheduleConsultation = () => {
    openContactModal("Schedule Consultation");
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setShowAllProjects(false);
    scrollTo("projects");
  };

  const handleSearch = () => {
    if (searchQuery.trim()) {
      scrollTo("projects");
    } else {
      setToast("🔍 Please enter a search term");
      setTimeout(() => setToast(""), 2800);
    }
  };

  const handlePhoneClick = () => {
    window.location.href = `tel:${PHONE_NUMBER}`;
  };

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${PHONE_NUMBER}`, "_blank");
  };

  const getFilteredProjects = () => {
    return PROJECTS.filter((project) => {
      const category = project.category || "Residential";
      return category === activeTab || (activeTab === "Residential" && category === "Residential");
    });
  };

  const filteredProjects = getFilteredProjects();
  const displayProjects = showAllProjects ? filteredProjects : filteredProjects.slice(0, 6);

  return (
    <div style={{ fontFamily: "'DM Sans', sans-serif", background: "#07101e", color: "#e8e0d0", minHeight: "100vh" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400;1,600&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        :root {
          --gold: #C9A84C;
          --gold-light: #E8C96A;
          --gold-dim: rgba(201,168,76,0.14);
          --dark: #07101e;
          --dark2: #0d1a2d;
          --dark3: #111f33;
          --text: #e8e0d0;
          --text2: rgba(232,224,208,0.55);
          --text3: rgba(232,224,208,0.3);
          --border: rgba(201,168,76,0.14);
          --card: rgba(255,255,255,0.04);
          --r: 6px;
          --rl: 10px;
        }

        html { scroll-behavior: smooth; }

        .animated-section {
          opacity: 0;
          transform: translateY(50px);
          transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .animated-section.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .ke-proj-card, .ke-excl-card, .ke-loc-card, .ke-dev-card {
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .ke-proj-card.card-visible, 
        .ke-excl-card.card-visible, 
        .ke-loc-card.card-visible, 
        .ke-dev-card.card-visible {
          opacity: 1;
          transform: translateY(0);
        }

        .ke-stat-item {
          opacity: 0;
          transform: translateY(20px);
          transition: all 0.6s ease;
        }
        .ke-stat-item.stat-visible {
          opacity: 1;
          transform: translateY(0);
        }

        .ke-toast {
          position: fixed;
          bottom: 40px;
          left: 50%;
          transform: translateX(-50%);
          background: var(--dark2);
          border: 1px solid var(--gold);
          color: var(--text);
          padding: 14px 28px;
          font-size: 14px;
          font-weight: 600;
          letter-spacing: 0.5px;
          z-index: 99999;
          display: flex;
          align-items: center;
          gap: 10px;
          border-radius: 8px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
          animation: toastIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
          backdrop-filter: blur(10px);
        }

        @keyframes toastIn {
          from { opacity: 0; transform: translateX(-50%) translateY(20px) scale(0.95); }
          to { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }
        }

        .ke-toast.out { animation: toastOut 0.3s ease forwards; }
        @keyframes toastOut {
          from { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }
          to { opacity: 0; transform: translateX(-50%) translateY(20px) scale(0.95); }
        }

        @media (max-width: 480px) {
          .ke-toast { font-size: 12px; padding: 12px 20px; bottom: 24px; white-space: normal; max-width: 90%; text-align: center; }
        }

        .ke-strip {
          background: var(--gold);
          padding: 10px 48px;
          display: flex; align-items: center; justify-content: center; gap: 12px;
          position: relative;
          z-index: 101;
        }
        .ke-strip p { font-size: 12px; font-weight: 700; color: var(--dark); text-align: center; letter-spacing: 0.4px; }
        .ke-strip a { color: var(--dark); font-weight: 800; text-decoration: underline; cursor: pointer; }

        .ke-nav {
          position: fixed; top: 0; left: 0; right: 0; z-index: 100;
          padding: 0 48px; height: 66px;
          display: flex; align-items: center; justify-content: space-between;
          transition: background 0.3s, border-color 0.3s;
          border-bottom: 1px solid transparent;
        }
        .ke-nav.scrolled {
          background: rgba(7,16,30,0.96);
          backdrop-filter: blur(14px);
          border-bottom-color: var(--border);
        }
        .ke-nav-logo { font-family: 'Playfair Display', serif; font-size: 20px; font-weight: 700; color: #f0e8d8; letter-spacing: 0.3px; }
        .ke-nav-logo span { color: var(--gold); }
        .ke-nav-links { display: flex; gap: 28px; }
        .ke-nav-links a { font-size: 12px; font-weight: 600; letter-spacing: 1px; text-transform: uppercase; color: var(--text2); text-decoration: none; transition: color 0.2s; cursor: pointer; }
        .ke-nav-links a:hover { color: var(--gold); }
        .ke-nav-cta {
          background: var(--gold); color: var(--dark); border: none;
          padding: 9px 22px; font-size: 11px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase;
          cursor: pointer; border-radius: var(--r); transition: background 0.2s;
        }
        .ke-nav-cta:hover { background: var(--gold-light); }

        .ke-hero {
          min-height: 100vh; position: relative;
          display: flex; flex-direction: column; justify-content: center;
        }
        .ke-hero-bg {
          position: absolute; inset: 0;
          background-size: cover; background-position: center;
          opacity: 0.50;
        }
        .ke-hero-inner {
          position: relative; z-index: 2;
          max-width: 1240px; margin: 0 auto;
          padding: 110px 48px 60px;
          display: grid; grid-template-columns: 1fr 420px; gap: 64px; align-items: center;
        }
        .ke-eyebrow {
          font-size: 10px; font-weight: 700; letter-spacing: 3.5px; color: var(--gold);
          text-transform: uppercase; margin-bottom: 20px;
          display: flex; align-items: center; gap: 10px;
        }
        .ke-eyebrow::before { content: ''; width: 28px; height: 1px; background: var(--gold); }
        .ke-h1 { font-family: 'Playfair Display', serif; font-size: clamp(44px, 6vw, 74px); font-weight: 700; line-height: 1.03; color: #f0e8d8; margin-bottom: 10px; }
        .ke-h1 em { font-style: italic; color: var(--gold); }
        .ke-hero-sub { font-family: 'Playfair Display', serif; font-style: italic; font-size: 17px; color: var(--text3); margin-bottom: 22px; }
        .ke-hero-desc { font-size: 15px; line-height: 1.85; color: var(--text2); max-width: 480px; margin-bottom: 36px; }
        .ke-hero-actions { display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 36px; }
        .ke-rating { display: flex; align-items: center; gap: 10px; }
        .ke-stars { display: flex; gap: 2px; }
        .ke-rating-text { font-size: 13px; color: var(--text3); }
        .ke-rating-text strong { color: var(--gold); }

        .ke-btn-gold {
          background: var(--gold); color: var(--dark); border: none;
          padding: 15px 32px; font-family: 'DM Sans', sans-serif; font-size: 12px; font-weight: 700;
          letter-spacing: 1px; text-transform: uppercase; cursor: pointer; border-radius: var(--r);
          transition: all 0.22s; display: inline-flex; align-items: center; gap: 8px;
        }
        .ke-btn-gold:hover { background: var(--gold-light); gap: 12px; }
        .ke-btn-ghost {
          background: transparent; color: var(--gold); border: 1px solid rgba(201,168,76,0.3);
          padding: 15px 32px; font-family: 'DM Sans', sans-serif; font-size: 12px; font-weight: 600;
          letter-spacing: 1px; text-transform: uppercase; cursor: pointer; border-radius: var(--r);
          transition: all 0.22s; display: inline-flex; align-items: center; gap: 8px;
        }
        .ke-btn-ghost:hover { border-color: var(--gold); background: var(--gold-dim); }

        .ke-hero-cards { display: flex; flex-direction: column; gap: 10px; }
        .ke-hero-card {
          background: rgba(7,16,30,0.75); backdrop-filter: blur(10px);
          border: 1px solid var(--border); border-radius: var(--rl);
          padding: 20px 22px; cursor: pointer; transition: all 0.25s;
        }
        .ke-hero-card:hover { border-color: rgba(201,168,76,0.4); background: rgba(201,168,76,0.15); transform: translateX(4px); }
        .ke-hc-top { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 6px; }
        .ke-hc-name { font-family: 'Playfair Display', serif; font-size: 15px; color: #f0e8d8; font-weight: 600; }
        .ke-hc-price { font-size: 14px; font-weight: 700; color: var(--gold); }
        .ke-hc-loc { font-size: 11px; color: var(--text3); margin-bottom: 10px; display: flex; align-items: center; gap: 4px; }
        .ke-hc-tags { display: flex; gap: 6px; flex-wrap: wrap; }
        .ke-hc-tag { font-size: 9px; padding: 3px 9px; border: 1px solid rgba(201,168,76,0.2); color: rgba(201,168,76,0.7); border-radius: 3px; font-weight: 600; letter-spacing: 0.4px; }

        .ke-search-wrap { position: relative; z-index: 2; max-width: 1240px; margin: 0 auto; padding: 0 48px 56px; }
        .ke-search-box {
          background: rgba(7,16,30,0.75); backdrop-filter: blur(16px);
          border: 1px solid rgba(201,168,76,0.2); border-radius: var(--rl);
          display: flex; align-items: center; overflow: hidden;
        }
        .ke-search-icon { padding: 0 16px; color: rgba(201,168,76,0.6); display: flex; align-items: center; flex-shrink: 0; }
        .ke-search-input { flex: 1; background: transparent; border: none; outline: none; color: var(--text); font-size: 14px; font-family: 'DM Sans', sans-serif; padding: 18px 0; }
        .ke-search-input::placeholder { color: var(--text3); }
        .ke-search-sep { width: 1px; height: 22px; background: var(--border); flex-shrink: 0; }
        .ke-search-sel { background: transparent; border: none; outline: none; color: var(--text2); font-family: 'DM Sans', sans-serif; font-size: 12px; padding: 0 18px; cursor: pointer; height: 58px; }
        .ke-search-sel option { background: #0d1a2d; }
        .ke-search-btn {
          background: var(--gold); color: var(--dark); border: none;
          padding: 0 28px; height: 58px; font-family: 'DM Sans', sans-serif; font-size: 12px; font-weight: 700;
          letter-spacing: 1px; text-transform: uppercase; cursor: pointer;
          display: flex; align-items: center; gap: 8px; flex-shrink: 0; transition: background 0.2s;
        }
        .ke-search-btn:hover { background: var(--gold-light); }

        .ke-stats-section { background: rgba(7,16,30,0.7); backdrop-filter: blur(4px); border-top: 1px solid var(--border); border-bottom: 1px solid var(--border); padding: 0 48px; }
        .ke-stats-inner { max-width: 1240px; margin: 0 auto; display: grid; grid-template-columns: repeat(4,1fr); }
        .ke-stat-item { text-align: center; padding: 52px 16px; border-right: 1px solid var(--border); }
        .ke-stat-item:last-child { border-right: none; }
        .ke-stat-val { font-family: 'Playfair Display', serif; font-size: clamp(38px,5vw,56px); font-weight: 700; color: var(--gold); line-height: 1; margin-bottom: 8px; transition: opacity 0.8s; }
        .ke-stat-lbl { font-size: 11px; color: var(--text3); letter-spacing: 2px; text-transform: uppercase; font-weight: 600; }

        .ke-section { max-width: 1240px; margin: 0 auto; padding: 80px 48px; position: relative; z-index: 2; }
        .ke-sec-ey { font-size: 10px; font-weight: 700; letter-spacing: 3.5px; color: var(--gold); text-transform: uppercase; margin-bottom: 12px; display: flex; align-items: center; gap: 10px; }
        .ke-sec-ey::before { content: ''; width: 22px; height: 1px; background: var(--gold); }
        .ke-sec-title { font-family: 'Playfair Display', serif; font-size: clamp(26px,4vw,42px); font-weight: 700; color: #f0e8d8; margin-bottom: 12px; }
        .ke-sec-sub { font-size: 14px; line-height: 1.8; color: var(--text2); max-width: 520px; }
        .ke-sec-header { margin-bottom: 44px; }

        .ke-tabs { display: flex; border-bottom: 1px solid var(--border); margin-bottom: 32px; flex-wrap: wrap; gap: 4px; }
        .ke-tab { background: transparent; border: none; border-bottom: 2px solid transparent; margin-bottom: -1px; padding: 12px 26px; font-family: 'DM Sans', sans-serif; font-size: 12px; font-weight: 600; letter-spacing: 0.5px; color: var(--text3); cursor: pointer; transition: all 0.2s; }
        .ke-tab.active { color: var(--gold); border-bottom-color: var(--gold); }

        .ke-proj-grid { 
          display: grid; 
          grid-template-columns: repeat(3,1fr); 
          gap: 24px; 
          margin-bottom: 36px; 
        }
        @media (max-width: 1024px) { .ke-proj-grid { grid-template-columns: repeat(2,1fr); } }
        @media (max-width: 680px) { .ke-proj-grid { grid-template-columns: 1fr; } }
        
        .ke-proj-card {
          background: rgba(7,16,30,0.7);
          backdrop-filter: blur(8px);
          border-radius: var(--rl);
          overflow: hidden;
          cursor: pointer;
          transition: all 0.3s ease;
          border: 1px solid var(--border);
        }
        .ke-proj-card:hover {
          transform: translateY(-5px);
          border-color: var(--gold);
          background: rgba(201,168,76,0.1);
        }
        .ke-proj-image-wrapper {
          position: relative;
          height: 200px;
          overflow: hidden;
        }
        .ke-proj-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }
        .ke-proj-card:hover .ke-proj-image { transform: scale(1.05); }
        .ke-proj-badge {
          position: absolute;
          top: 12px;
          left: 12px;
          display: inline-block;
          font-size: 8px;
          font-weight: 700;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          padding: 4px 10px;
          background: var(--gold);
          color: var(--dark);
          border-radius: 3px;
          z-index: 2;
        }
        .ke-proj-content { padding: 20px; }
        .ke-proj-name { font-family: 'Playfair Display', serif; font-size: 16px; font-weight: 600; color: #f0e8d8; margin-bottom: 5px; }
        .ke-proj-loc { font-size: 11px; color: var(--text3); margin-bottom: 14px; display: flex; align-items: center; gap: 4px; }
        .ke-proj-price { font-family: 'Playfair Display', serif; font-size: 19px; color: var(--gold); font-weight: 600; margin-bottom: 4px; }
        .ke-proj-meta { font-size: 11px; color: var(--text3); line-height: 1.8; }
        .ke-proj-link { display: flex; align-items: center; gap: 6px; font-size: 10px; font-weight: 700; color: rgba(201,168,76,0.6); letter-spacing: 1px; text-transform: uppercase; margin-top: 16px; transition: all 0.2s; }
        .ke-proj-card:hover .ke-proj-link { gap: 10px; color: var(--gold); }

        .ke-excl-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 24px; }
        @media (max-width: 1024px) { .ke-excl-grid { grid-template-columns: repeat(2,1fr); } }
        @media (max-width: 680px) { .ke-excl-grid { grid-template-columns: 1fr; } }
        .ke-excl-card {
          background: rgba(7,16,30,0.7);
          backdrop-filter: blur(8px);
          border: 1px solid var(--border);
          border-radius: var(--rl);
          overflow: hidden;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .ke-excl-card:hover {
          transform: translateY(-5px);
          border-color: var(--gold);
          background: rgba(201,168,76,0.1);
        }
        .ke-excl-image-wrapper { position: relative; height: 200px; overflow: hidden; }
        .ke-excl-image { width: 100%; height: 100%; object-fit: cover; transition: transform 0.3s ease; }
        .ke-excl-card:hover .ke-excl-image { transform: scale(1.05); }
        .ke-excl-badge {
          position: absolute;
          top: 12px;
          right: 12px;
          font-size: 8px;
          font-weight: 700;
          letter-spacing: 2px;
          color: var(--gold);
          text-transform: uppercase;
          background: rgba(0,0,0,0.6);
          padding: 4px 10px;
          border-radius: 3px;
          z-index: 2;
        }
        .ke-excl-content { padding: 20px; }
        .ke-excl-name { font-family: 'Playfair Display', serif; font-size: 16px; color: #f0e8d8; font-weight: 600; margin-bottom: 5px; }
        .ke-excl-loc { font-size: 11px; color: var(--text3); margin-bottom: 14px; display: flex; align-items: center; gap: 4px; }
        .ke-excl-price { font-size: 18px; color: var(--gold); font-weight: 700; margin-bottom: 3px; }
        .ke-excl-bhk { font-size: 11px; color: var(--text3); }

        .ke-loc-grid { display: grid; grid-template-columns: repeat(5,1fr); gap: 16px; }
        @media (max-width: 1024px) { .ke-loc-grid { grid-template-columns: repeat(3,1fr); } }
        @media (max-width: 680px) { .ke-loc-grid { grid-template-columns: repeat(2,1fr); } }
        @media (max-width: 420px) { .ke-loc-grid { grid-template-columns: 1fr; } }
        .ke-loc-card { cursor: pointer; border-radius: var(--rl); overflow: hidden; transition: all 0.3s ease; }
        .ke-loc-card:hover { transform: translateY(-5px); }
        .ke-loc-image-wrapper { position: relative; height: 180px; overflow: hidden; }
        .ke-loc-image { width: 100%; height: 100%; object-fit: cover; transition: transform 0.3s ease; }
        .ke-loc-card:hover .ke-loc-image { transform: scale(1.1); }
        .ke-loc-overlay {
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.7) 100%);
          z-index: 1;
        }
        .ke-loc-content {
          position: absolute;
          bottom: 0; left: 0; right: 0;
          padding: 20px 16px;
          z-index: 2;
          text-align: center;
        }
        .ke-loc-name { font-size: 14px; font-weight: 600; color: #fff; margin-bottom: 4px; font-family: 'Playfair Display', serif; }
        .ke-loc-count { font-size: 11px; color: var(--gold); font-weight: 500; }

        .ke-testi-wrap { max-width: 820px; margin: 0 auto; text-align: center; }
        .ke-testi-quote { font-family: 'Playfair Display', serif; font-style: italic; font-size: clamp(16px,2.2vw,21px); line-height: 1.8; color: rgba(232,224,208,0.85); margin-bottom: 32px; padding: 0 20px; }
        .ke-testi-quote::before { content: '201C'; font-size: 5rem; color: rgba(201,168,76,0.12); line-height: 0; vertical-align: -2rem; margin-right: 4px; }
        .ke-testi-avatar { width: 54px; height: 54px; border-radius: 50%; background: var(--gold-dim); border: 1.5px solid rgba(201,168,76,0.3); display: flex; align-items: center; justify-content: center; font-family: 'Playfair Display', serif; font-size: 16px; color: var(--gold); margin: 0 auto 12px; }
        .ke-testi-name { font-size: 15px; font-weight: 600; color: #e0d8c8; margin-bottom: 4px; }
        .ke-testi-city { font-size: 10px; color: var(--text3); letter-spacing: 2px; text-transform: uppercase; margin-bottom: 28px; }
        .ke-testi-nav { display: flex; justify-content: center; align-items: center; gap: 10px; }
        .ke-testi-btn { width: 40px; height: 40px; border: 1px solid rgba(201,168,76,0.25); background: rgba(7,16,30,0.6); color: var(--gold); cursor: pointer; display: flex; align-items: center; justify-content: center; border-radius: var(--r); transition: all 0.2s; }
        .ke-testi-btn:hover { border-color: var(--gold); background: var(--gold-dim); }
        .ke-testi-dot { width: 6px; height: 6px; border-radius: 50%; border: none; cursor: pointer; transition: background 0.3s; }

        .ke-dev-grid { display: grid; grid-template-columns: repeat(4,1fr); gap: 10px; }
        @media (max-width: 1024px) { .ke-dev-grid { grid-template-columns: repeat(3,1fr); } }
        @media (max-width: 680px) { .ke-dev-grid { grid-template-columns: repeat(2,1fr); } }
        @media (max-width: 420px) { .ke-dev-grid { grid-template-columns: 1fr; } }
        .ke-dev-card { background: rgba(7,16,30,0.6); backdrop-filter: blur(4px); border: 1px solid rgba(255,255,255,0.05); border-radius: var(--r); padding: 18px 20px; display: flex; align-items: center; gap: 12px; transition: all 0.3s ease; }
        .ke-dev-card:hover { border-color: var(--border); background: rgba(201,168,76,0.15); }
        .ke-dev-icon { width: 36px; height: 36px; border-radius: 50%; background: var(--gold-dim); display: flex; align-items: center; justify-content: center; flex-shrink: 0; font-family: 'Playfair Display', serif; font-size: 13px; color: var(--gold); font-weight: 700; }
        .ke-dev-name { font-size: 12px; font-weight: 600; color: var(--text2); }

        .ke-divider-section {
          position: relative;
          height: 400px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          overflow: hidden;
        }
        @media (max-width: 680px) { .ke-divider-section { height: 300px; } }
        .ke-divider-bg {
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background-size: cover;
          background-position: center;
          background-attachment: fixed;
        }
        .ke-divider-overlay {
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: linear-gradient(135deg, rgba(7,16,30,0.85) 0%, rgba(13,26,45,0.8) 100%);
        }
        .ke-divider-content {
          position: relative;
          z-index: 2;
          max-width: 800px;
          padding: 0 24px;
        }
        .ke-divider-title {
          font-family: 'Playfair Display', serif;
          font-size: clamp(32px, 5vw, 48px);
          font-weight: 700;
          color: #f0e8d8;
          margin-bottom: 16px;
        }
        .ke-divider-subtitle {
          font-size: 16px;
          color: var(--text2);
          margin-bottom: 32px;
          line-height: 1.6;
        }
        .ke-divider-btn { margin-top: 16px; }

        .ke-cta-section { padding: 80px 48px; position: relative; z-index: 1; }
        .ke-cta-inner { max-width: 1240px; margin: 0 auto; display: grid; grid-template-columns: 1.3fr 1fr; gap: 64px; align-items: center; }
        @media (max-width: 900px) {
          .ke-cta-inner { grid-template-columns: 1fr; gap: 36px; }
          .ke-cta-section { padding: 56px 24px; }
        }
        .ke-cta-h2 { font-family: 'Playfair Display', serif; font-size: clamp(28px,4vw,44px); font-weight: 700; color: #f0e8d8; margin-bottom: 14px; }
        .ke-cta-desc { font-size: 14px; color: var(--text2); line-height: 1.85; margin-bottom: 28px; }
        .ke-phone-row { display: flex; align-items: center; gap: 14px; text-decoration: none; margin-bottom: 12px; }
        .ke-phone-icon { width: 46px; height: 46px; border: 1px solid rgba(201,168,76,0.3); border-radius: var(--r); display: flex; align-items: center; justify-content: center; color: var(--gold); flex-shrink: 0; }
        .ke-phone-num { font-family: 'Playfair Display', serif; font-size: 21px; color: var(--gold); font-weight: 600; }
        .ke-phone-lbl { font-size: 10px; color: var(--text3); letter-spacing: 1.5px; text-transform: uppercase; margin-bottom: 2px; }
        .ke-wa-btn { display: flex; align-items: center; gap: 10px; background: rgba(37,211,102,0.08); border: 1px solid rgba(37,211,102,0.25); padding: 13px 22px; font-size: 13px; font-weight: 600; color: #25D366; cursor: pointer; text-decoration: none; border-radius: var(--r); transition: all 0.2s; margin-bottom: 12px; }
        .ke-wa-btn:hover { background: rgba(37,211,102,0.14); }

        .ke-contact-form { background: rgba(7,16,30,0.7); backdrop-filter: blur(8px); border: 1px solid var(--border); border-radius: var(--rl); padding: 28px; display: flex; flex-direction: column; gap: 10px; }
        @media (max-width: 480px) { .ke-contact-form { padding: 20px; } }
        .ke-form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
        @media (max-width: 480px) { .ke-form-row { grid-template-columns: 1fr; } }
        .ke-form-input { background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: var(--r); padding: 11px 14px; font-size: 13px; color: var(--text); font-family: 'DM Sans', sans-serif; outline: none; transition: border-color 0.2s; width: 100%; }
        .ke-form-input:focus { border-color: rgba(201,168,76,0.4); }
        .ke-form-input::placeholder { color: var(--text3); }
        .ke-form-input.error { border-color: #ff6b6b !important; }
        .ke-form-input.error:focus { border-color: #ff6b6b !important; box-shadow: 0 0 0 1px #ff6b6b; }

        .ke-contact-modal-overlay {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.92);
          backdrop-filter: blur(12px);
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          animation: fadeIn 0.3s ease;
        }
        .ke-contact-modal-content {
          background: linear-gradient(145deg, #0d1a2d 0%, #07101e 100%);
          border: 1px solid rgba(201,168,76,0.2);
          border-radius: 16px;
          max-width: 560px;
          width: 100%;
          max-height: 90vh;
          overflow-y: auto;
          position: relative;
          animation: slideUp 0.4s cubic-bezier(0.34,1.56,0.64,1);
          box-shadow: 0 24px 80px rgba(0,0,0,0.6);
          padding: 40px 36px;
        }
        .ke-contact-modal-content::-webkit-scrollbar { width: 4px; }
        .ke-contact-modal-content::-webkit-scrollbar-track { background: transparent; }
        .ke-contact-modal-content::-webkit-scrollbar-thumb { background: var(--gold); border-radius: 2px; }
        .ke-contact-modal-close {
          position: absolute;
          top: 16px; right: 16px;
          background: rgba(0,0,0,0.5);
          border: 1px solid rgba(255,255,255,0.1);
          border-radius: 50%;
          width: 40px; height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          cursor: pointer;
          transition: all 0.3s ease;
          z-index: 10;
        }
        .ke-contact-modal-close:hover { background: rgba(201,168,76,0.2); border-color: var(--gold); transform: rotate(90deg); }
        .ke-contact-modal-close svg { width: 20px; height: 20px; }
        .ke-contact-steps { display: flex; gap: 8px; margin-bottom: 28px; justify-content: center; }
        .ke-contact-step-dot { width: 30px; height: 3px; border-radius: 2px; background: var(--border); transition: background 0.3s; }
        .ke-contact-step-dot.active { background: var(--gold); }

        .ke-float-wa { position: fixed; bottom: 28px; right: 28px; z-index: 200; width: 52px; height: 52px; border-radius: 50%; background: #25D366; color: #fff; display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 20px rgba(37,211,102,0.35); cursor: pointer; text-decoration: none; transition: transform 0.2s; }
        .ke-float-wa:hover { transform: scale(1.1); }
        @media (max-width: 480px) { .ke-float-wa { width: 44px; height: 44px; bottom: 20px; right: 20px; } }

        .ke-popup-overlay {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.85);
          backdrop-filter: blur(12px);
          z-index: 9998;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          animation: fadeIn 0.3s ease;
        }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(40px) scale(0.95); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        .ke-popup-content {
          background: linear-gradient(145deg, #0d1a2d 0%, #07101e 100%);
          border: 1px solid rgba(201,168,76,0.2);
          border-radius: 16px;
          max-width: 520px;
          width: 100%;
          max-height: 90vh;
          overflow-y: auto;
          position: relative;
          animation: slideUp 0.4s cubic-bezier(0.34,1.56,0.64,1);
          box-shadow: 0 24px 80px rgba(0,0,0,0.6);
        }
        .ke-popup-content::-webkit-scrollbar { width: 4px; }
        .ke-popup-content::-webkit-scrollbar-track { background: transparent; }
        .ke-popup-content::-webkit-scrollbar-thumb { background: var(--gold); border-radius: 2px; }
        .ke-popup-close {
          position: absolute;
          top: 16px; right: 16px;
          background: rgba(0,0,0,0.5);
          border: 1px solid rgba(255,255,255,0.1);
          border-radius: 50%;
          width: 40px; height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          cursor: pointer;
          transition: all 0.3s ease;
          z-index: 10;
        }
        .ke-popup-close:hover { background: rgba(201,168,76,0.2); border-color: var(--gold); transform: rotate(90deg); }
        .ke-popup-close svg { width: 20px; height: 20px; }
        .ke-popup-image-wrapper { position: relative; height: 240px; overflow: hidden; border-radius: 16px 16px 0 0; }
        .ke-popup-image { width: 100%; height: 100%; object-fit: cover; }
        .ke-popup-badge {
          position: absolute;
          top: 16px; left: 16px;
          background: var(--gold);
          color: var(--dark);
          padding: 4px 12px;
          border-radius: 4px;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 1.5px;
          text-transform: uppercase;
        }
        .ke-popup-body { padding: 28px 24px 24px; }
        .ke-popup-title { font-family: 'Playfair Display', serif; font-size: 24px; font-weight: 700; color: #f0e8d8; margin-bottom: 6px; }
        .ke-popup-location { font-size: 13px; color: var(--text3); display: flex; align-items: center; gap: 4px; margin-bottom: 12px; }
        .ke-popup-price { font-family: 'Playfair Display', serif; font-size: 28px; font-weight: 700; color: var(--gold); margin-bottom: 20px; }
        .ke-popup-details {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
          margin-bottom: 24px;
          padding: 16px;
          background: rgba(255,255,255,0.04);
          border-radius: 10px;
          border: 1px solid rgba(255,255,255,0.06);
        }
        .ke-popup-detail-item { display: flex; flex-direction: column; gap: 2px; }
        .ke-popup-detail-label { font-size: 10px; font-weight: 600; color: var(--text3); text-transform: uppercase; letter-spacing: 1px; }
        .ke-popup-detail-value { font-size: 14px; font-weight: 600; color: #f0e8d8; }
        .ke-popup-actions { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 16px; }
        .ke-popup-btn-call, .ke-popup-btn-whatsapp {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 12px 20px;
          border: none;
          border-radius: 8px;
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .ke-popup-btn-call {
          background: linear-gradient(135deg, #C9A84C, #E8C96A);
          color: #07101e;
        }
        .ke-popup-btn-call:hover { transform: translateY(-2px); box-shadow: 0 4px 20px rgba(201,168,76,0.4); }
        .ke-popup-btn-whatsapp {
          background: rgba(37,211,102,0.15);
          color: #25D366;
          border: 1px solid rgba(37,211,102,0.25);
        }
        .ke-popup-btn-whatsapp:hover { background: rgba(37,211,102,0.25); transform: translateY(-2px); }
        .ke-popup-btn-whatsapp svg { fill: #25D366; }
        .ke-popup-contact { text-align: center; font-size: 13px; color: var(--text2); padding-top: 12px; border-top: 1px solid var(--border); }

        .ke-popup-nav-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(0,0,0,0.6);
          color: #fff;
          border: none;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          font-size: 20px;
          cursor: pointer;
          z-index: 5;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .ke-popup-nav-btn:hover { background: rgba(201,168,76,0.8); }
        .ke-popup-nav-prev { left: 12px; }
        .ke-popup-nav-next { right: 12px; }

        .ke-popup-dots {
          position: absolute;
          bottom: 16px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 8px;
          z-index: 5;
        }
        .ke-popup-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: rgba(255,255,255,0.4);
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .ke-popup-dot.active { background: var(--gold); transform: scale(1.2); }

        .ke-popup-media-controls {
          position: absolute;
          bottom: 16px;
          right: 16px;
          display: flex;
          gap: 10px;
          z-index: 5;
        }
        .ke-popup-media-btn {
          background: rgba(0,0,0,0.7);
          color: #fff;
          border: 1px solid rgba(255,255,255,0.2);
          padding: 6px 14px;
          border-radius: 20px;
          font-size: 11px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          backdrop-filter: blur(4px);
        }
        .ke-popup-media-btn:hover { background: var(--gold); color: #07101e; border-color: var(--gold); }
        .ke-popup-media-btn.active { background: var(--gold); color: #07101e; border-color: var(--gold); }
        .ke-popup-image-counter {
          background: rgba(0,0,0,0.7);
          color: #fff;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 11px;
          font-weight: 600;
          backdrop-filter: blur(4px);
        }

        .ke-popup-video-container {
          position: relative;
          width: 100%;
          height: 100%;
          background: #000;
        }
        .ke-popup-video { width: 100%; height: 100%; border: none; }
        .ke-popup-close-video {
          position: absolute;
          top: 12px;
          right: 12px;
          background: rgba(0,0,0,0.7);
          color: #fff;
          border: none;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          font-size: 16px;
          cursor: pointer;
          z-index: 5;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .ke-popup-close-video:hover { background: #ff4444; }

        @media (max-width: 480px) {
          .ke-popup-content { max-width: 100%; margin: 10px; border-radius: 12px; }
          .ke-popup-image-wrapper { height: 180px; }
          .ke-popup-body { padding: 20px 16px 16px; }
          .ke-popup-title { font-size: 20px; }
          .ke-popup-price { font-size: 24px; }
          .ke-popup-actions { grid-template-columns: 1fr; }
          .ke-popup-details { grid-template-columns: 1fr; }
          .ke-popup-close { top: 12px; right: 12px; width: 32px; height: 32px; }
          .ke-contact-modal-content { padding: 28px 20px; margin: 10px; }
          .ke-popup-nav-btn { width: 28px; height: 28px; font-size: 16px; }
          .ke-popup-nav-prev { left: 8px; }
          .ke-popup-nav-next { right: 8px; }
          .ke-popup-dots { gap: 6px; }
          .ke-popup-dot { width: 6px; height: 6px; }
          .ke-popup-media-btn { font-size: 10px; padding: 4px 10px; }
          .ke-popup-image-counter { font-size: 10px; padding: 3px 10px; }
        }

        .ke-footer { background: rgba(7,16,30,0.95); backdrop-filter: blur(4px); border-top: 1px solid var(--border); padding: 48px 48px 28px; }
        .ke-footer-inner { max-width: 1240px; margin: 0 auto; }
        .ke-footer-top { display: grid; grid-template-columns: 1.5fr 1fr 1fr 1fr; gap: 48px; margin-bottom: 40px; }
        @media (max-width: 900px) {
          .ke-footer { padding: 40px 24px 24px; }
          .ke-footer-top { grid-template-columns: 1fr 1fr; gap: 28px; }
        }
        @media (max-width: 480px) { .ke-footer-top { grid-template-columns: 1fr; gap: 24px; } }
        .ke-footer-logo { font-family: 'Playfair Display', serif; font-size: 22px; font-weight: 700; color: #f0e8d8; }
        .ke-footer-desc { font-size: 13px; color: var(--text3); line-height: 1.8; margin-top: 10px; max-width: 240px; }
        .ke-footer-heading { font-size: 10px; font-weight: 700; letter-spacing: 2.5px; text-transform: uppercase; color: var(--gold); margin-bottom: 16px; }
        .ke-footer-links { display: flex; flex-direction: column; gap: 10px; }
        .ke-footer-links a { font-size: 13px; color: var(--text3); text-decoration: none; transition: color 0.2s; cursor: pointer; }
        .ke-footer-links a:hover { color: var(--gold); }
        .ke-footer-social { display: flex; gap: 10px; margin-top: 16px; flex-wrap: wrap; }
        .ke-social-btn { width: 34px; height: 34px; border: 1px solid var(--border); border-radius: 50%; display: flex; align-items: center; justify-content: center; color: var(--text3); cursor: pointer; transition: all 0.2s; font-size: 11px; font-weight: 700; background: rgba(7,16,30,0.6); }
        .ke-social-btn:hover { border-color: var(--gold); color: var(--gold); }
        .ke-footer-bottom { border-top: 1px solid var(--border); padding-top: 20px; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; }
        @media (max-width: 900px) { .ke-footer-bottom { flex-direction: column; text-align: center; } }
        .ke-footer-copy { font-size: 12px; color: var(--text3); }

        .ke-center { display: flex; justify-content: center; }

        @media (max-width: 1024px) {
          .ke-hero-inner { grid-template-columns: 1fr; gap: 40px; padding: 80px 32px 40px; }
          .ke-hero-desc { max-width: 100%; }
          .ke-section { padding: 60px 32px; }
          .ke-stats-section { padding: 0 32px; }
          .ke-search-wrap { padding: 0 32px 40px; }
        }
        @media (max-width: 768px) {
          .ke-hero-inner { padding: 70px 24px 32px; gap: 32px; }
          .ke-hero-actions { flex-direction: column; width: 100%; }
          .ke-hero-actions button { width: 100%; justify-content: center; }
          .ke-section { padding: 48px 24px; }
          .ke-stats-section { padding: 0 24px; }
          .ke-stats-inner { grid-template-columns: repeat(2,1fr); }
          .ke-stat-item { padding: 32px 16px; border-right: none; border-bottom: 1px solid var(--border); }
          .ke-stat-item:nth-child(odd) { border-right: 1px solid var(--border); }
          .ke-stat-item:last-child { border-bottom: none; }
          .ke-search-wrap { padding: 0 24px 32px; }
          .ke-search-box { flex-wrap: wrap; }
          .ke-search-input { padding: 14px 16px; width: 100%; flex: none; }
          .ke-search-sep { display: none; }
          .ke-search-sel { padding: 12px 16px; height: 48px; width: 50%; }
          .ke-search-btn { width: 100%; justify-content: center; height: 48px; padding: 0 16px; }
          .ke-tabs { gap: 0; }
          .ke-tab { padding: 10px 16px; font-size: 11px; }
        }
        @media (max-width: 480px) {
          .ke-hero-inner { padding: 60px 16px 24px; }
          .ke-h1 { font-size: 32px; }
          .ke-hero-sub { font-size: 15px; }
          .ke-hero-desc { font-size: 14px; }
          .ke-section { padding: 32px 16px; }
          .ke-sec-title { font-size: 24px; }
          .ke-sec-sub { font-size: 13px; }
          .ke-proj-content { padding: 16px; }
          .ke-excl-content { padding: 16px; }
          .ke-divider-section { height: 250px; }
          .ke-divider-title { font-size: 28px; }
          .ke-divider-subtitle { font-size: 14px; }
          .ke-cta-section { padding: 40px 16px; }
          .ke-testi-quote { font-size: 15px; padding: 0 12px; }
          .ke-testi-quote::before { font-size: 3rem; }
          .ke-btn-gold, .ke-btn-ghost { padding: 12px 24px; font-size: 11px; width: 100%; justify-content: center; }
          .ke-btn-gold:hover, .ke-btn-ghost:hover { width: 100%; }
          .ke-hero-cards .ke-btn-ghost { width: 100%; justify-content: center; }
          .ke-stats-section { padding: 0 16px; }
          .ke-stat-item { padding: 24px 12px; }
          .ke-stat-val { font-size: 28px; }
          .ke-stat-lbl { font-size: 10px; }
          .ke-nav-cta { display: none; }
        }
        @media (max-width: 360px) {
          .ke-hero-inner { padding: 50px 12px 20px; }
          .ke-h1 { font-size: 28px; }
          .ke-hero-sub { font-size: 13px; }
          .ke-hero-desc { font-size: 13px; }
          .ke-section { padding: 24px 12px; }
          .ke-sec-title { font-size: 20px; }
          .ke-proj-image-wrapper, .ke-excl-image-wrapper { height: 160px; }
          .ke-loc-image-wrapper { height: 140px; }
          .ke-proj-name, .ke-excl-name { font-size: 14px; }
          .ke-proj-price, .ke-excl-price { font-size: 16px; }
          .ke-divider-section { height: 220px; }
          .ke-divider-title { font-size: 24px; }
          .ke-phone-num { font-size: 18px; }
          .ke-search-sel { font-size: 11px; padding: 8px 12px; }
          .ke-tab { font-size: 10px; padding: 8px 12px; }
        }
        @media (hover: none) {
          .ke-proj-card:hover, .ke-excl-card:hover, .ke-loc-card:hover, .ke-hero-card:hover { transform: none; }
          .ke-proj-card:active, .ke-excl-card:active, .ke-loc-card:active { transform: scale(0.98); }
          .ke-proj-link { gap: 10px; color: var(--gold); }
        }
        @media print {
          .ke-hero-bg { opacity: 0.1; }
          .ke-nav, .ke-strip, .ke-float-wa { display: none; }
          .ke-btn-gold, .ke-btn-ghost { background: #333 !important; color: #fff !important; border: 1px solid #666 !important; }
          .ke-hero { min-height: 50vh; }
          .ke-divider-section { height: 200px; }
          .ke-stats-inner { display: flex; justify-content: space-around; }
        }
      `}</style>

      {/* ─── NAVIGATION ── */}
      <nav className={`ke-nav ${navScrolled ? "scrolled" : ""}`}>
        <div className="ke-nav-logo">Next<span>Front</span></div>
        <div className="ke-nav-links">
          <a onClick={() => scrollTo("home")}>Home</a>
          <a onClick={() => scrollTo("projects")}>Projects</a>
          <a onClick={() => scrollTo("localities")}>Localities</a>
          <a onClick={() => scrollTo("exclusive")}>Exclusive</a>
          <a onClick={() => scrollTo("testimonials")}>Reviews</a>
          <a onClick={() => scrollTo("cta")}>Contact</a>
        </div>
        <button className="ke-nav-cta" onClick={handleTalkToExpert}>Enquire Now</button>
      </nav>

      {/* ─── HERO SECTION ── */}
      <section className="ke-hero" id="home">
        <div className="ke-hero-bg" style={{ backgroundImage: `url(${IMAGES.hero})` }} />
        <div className="ke-hero-inner">
          <div>
            <p className="ke-eyebrow">The City of Joy · Real Estate</p>
            <h1 className="ke-h1">
              Find Your<br />Perfect Home<br />in <em>Kolkata</em>
            </h1>
            <p className="ke-hero-sub">Where heritage meets the future of living</p>
            <p className="ke-hero-desc">
              Backed by 35 years of trust and deep partnerships with Kolkata's finest developers —
              from Newtown's planned skyline to Alipore's heritage lanes.
            </p>
            <div className="ke-hero-actions">
              <button className="ke-btn-gold" onClick={() => scrollTo("projects")}>
                Explore Projects <IconArrow />
              </button>
              <button className="ke-btn-ghost" onClick={handleTalkToExpert}>
                Talk to an Expert
              </button>
            </div>
            <div className="ke-rating">
              <div className="ke-stars">
                {[1, 2, 3, 4, 5].map(i => <IconStar key={i} />)}
              </div>
              <p className="ke-rating-text"><strong>4.9</strong> · 2,500+ Happy Families</p>
            </div>
          </div>
          <div className="ke-hero-cards">
            {PROJECTS.slice(0, 3).map(p => (
              <div key={p.id} className="ke-hero-card" onClick={() => handleProjectView(p)}>
                <div className="ke-hc-top">
                  <div className="ke-hc-name">{p.name}</div>
                  <div className="ke-hc-price">{p.price}</div>
                </div>
                <div className="ke-hc-loc"><IconPin /> {p.location}</div>
                <div className="ke-hc-tags">
                  <span className="ke-hc-tag">{p.bhk}</span>
                  <span className="ke-hc-tag">{p.developer}</span>
                </div>
              </div>
            ))}
            <button className="ke-btn-ghost" style={{ width: "100%", justifyContent: "center" }} onClick={handleViewAllProjects}>
              View All Projects <IconArrow />
            </button>
          </div>
        </div>
        <div className="ke-search-wrap">
          <div className="ke-search-box">
            <span className="ke-search-icon"><IconSearch size={17} /></span>
            <input
              className="ke-search-input"
              placeholder="Search by locality, project or developer…"
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleSearch()}
            />
            <span className="ke-search-sep" />
            <select className="ke-search-sel" onChange={(e) => setActiveTab(e.target.value)} value={activeTab}>
              <option>All Types</option>
              <option>Residential</option>
              <option>Commercial</option>
              <option>Land</option>
            </select>
            <span className="ke-search-sep" />
            <select className="ke-search-sel">
              <option>Any Budget</option>
              <option>Under ₹50 Lac</option>
              <option>₹50L – ₹1 Cr</option>
              <option>₹1Cr – ₹2Cr</option>
              <option>Above ₹2 Cr</option>
            </select>
            <button className="ke-search-btn" onClick={handleSearch}>
              <IconSearch /> Search
            </button>
          </div>
        </div>
      </section>

      {/* ─── STATS SECTION ── */}
      <div className="ke-stats-section" ref={statsRef}>
        <div className="ke-stats-inner">
          {STATS.map((stat, idx) => (
            <div key={idx} className={`ke-stat-item ${visibleStats ? "stat-visible" : ""}`} style={{ transitionDelay: `${idx * 0.1}s` }}>
              <div className="ke-stat-val">{stat.value}</div>
              <div className="ke-stat-lbl">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ─── DIVIDER 1 ── */}
      <DividerSection 
        bgImage={IMAGES.divider1}
        title="Dream Homes Made Easy"
        subtitle="Find your perfect home in Kolkata with our expert guidance and verified listings"
        delay={0.1}
        onExplore={handleExploreNow}
      />

      {/* ─── PROJECTS SECTION ── */}
      <BgSection bgImage={IMAGES.projects} id="projects">
        <div className="ke-section">
          <AnimatedSection delay={1.5}>
            <div className="ke-sec-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: "16px" }}>
              <div>
                <p className="ke-sec-ey">Most Viewed</p>
                <h2 className="ke-sec-title">Featured Projects in Kolkata</h2>
                <p className="ke-sec-sub">Top properties known for prime locations, modern amenities, and strong investment potential across Kolkata's key micro-markets.</p>
              </div>
              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                {showAllProjects && (
                  <button 
                    className="ke-btn-ghost" 
                    onClick={handleShowLess}
                    style={{ padding: "8px 20px", fontSize: "10px" }}
                  >
                    Show Less ↑
                  </button>
                )}
              </div>
            </div>
          </AnimatedSection>
          <div className="ke-tabs">
            {TABS.map(t => (
              <button 
                key={t} 
                className={`ke-tab${activeTab === t ? " active" : ""}`} 
                onClick={() => {
                  setActiveTab(t);
                  setShowAllProjects(false);
                  scrollTo("projects");
                }}
              >
                {t}
              </button>
            ))}
          </div>
          <div className="ke-proj-grid">
            {displayProjects.map((project, index) => (
              <ProjectCard key={project.id} project={project} delay={1.0 + (index * 0.1)} onViewDetails={handleProjectView} />
            ))}
          </div>
          <div className="ke-center">
            {!showAllProjects && filteredProjects.length > 6 && (
              <button className="ke-btn-gold" onClick={handleViewAllProjects}>
                View All Projects <IconArrow />
              </button>
            )}
            {showAllProjects && (
              <button className="ke-btn-ghost" onClick={handleShowLess}>
                Show Less <IconArrow dir="left" />
              </button>
            )}
          </div>
        </div>
      </BgSection>

      {/* ─── LOCALITIES SECTION ── */}
      <BgSection bgImage={IMAGES.localities} id="localities">
        <div className="ke-section">
          <AnimatedSection delay={1.5}>
            <div className="ke-sec-header">
              <p className="ke-sec-ey">Browse by Location</p>
              <h2 className="ke-sec-title">Kolkata's Key Micro-Markets</h2>
              <p className="ke-sec-sub">Explore properties across Kolkata's most sought-after neighbourhoods.</p>
            </div>
          </AnimatedSection>
          <div className="ke-loc-grid">
            {LOCALITIES.slice(0, 10).map((locality, index) => (
              <LocalityCard key={locality.id} locality={locality} delay={index * 0.05} onSelect={handleLocalitySelect} />
            ))}
          </div>
        </div>
      </BgSection>

      {/* ─── EXCLUSIVE SECTION ── */}
      <BgSection bgImage={IMAGES.exclusive} id="exclusive">
        <div className="ke-section">
          <AnimatedSection delay={1.2}>
            <div className="ke-sec-header">
              <p className="ke-sec-ey">NextFront Exclusive</p>
              <h2 className="ke-sec-title">Exclusive Listings</h2>
              <p className="ke-sec-sub">Thoughtfully curated properties offering unmatched design, privacy, and premium amenities.</p>
            </div>
          </AnimatedSection>
          <div className="ke-excl-grid">
            {EXCLUSIVE.map((item, index) => (
              <ExclusiveCard key={item.id} item={item} delay={index * 0.1} onViewDetails={handleProjectView} />
            ))}
          </div>
        </div>
      </BgSection>

      {/* ─── TESTIMONIALS SECTION ── */}
      <BgSection bgImage={IMAGES.testimonials} id="testimonials">
        <div style={{ padding: "80px 48px" }}>
          <div style={{ maxWidth: 1240, margin: "0 auto" }}>
            <AnimatedSection delay={1.2}>
              <div className="ke-sec-header" style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
                <p className="ke-sec-ey" style={{ justifyContent: "center" }}>Client Reviews</p>
                <h2 className="ke-sec-title" style={{ textAlign: "center" }}>What Our Clients Say</h2>
              </div>
            </AnimatedSection>
            <div className="ke-testi-wrap">
              <p className="ke-testi-quote">{TESTIMONIALS[testimonialIdx].text}</p>
              <div className="ke-testi-avatar">{TESTIMONIALS[testimonialIdx].initials}</div>
              <p className="ke-testi-name">{TESTIMONIALS[testimonialIdx].name}</p>
              <p className="ke-testi-city">Kolkata, India</p>
              <div className="ke-testi-nav">
                <button className="ke-testi-btn" onClick={() => setTestimonialIdx(i => (i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length)}>
                  <IconArrow dir="left" />
                </button>
                {TESTIMONIALS.map((_, i) => (
                  <button
                    key={i}
                    className="ke-testi-dot"
                    onClick={() => setTestimonialIdx(i)}
                    style={{ background: i === testimonialIdx ? "#C9A84C" : "rgba(201,168,76,0.2)" }}
                  />
                ))}
                <button className="ke-testi-btn" onClick={() => setTestimonialIdx(i => (i + 1) % TESTIMONIALS.length)}>
                  <IconArrow />
                </button>
              </div>
            </div>
          </div>
        </div>
      </BgSection>

      {/* ─── CTA SECTION ── */}
      <BgSection bgImage={IMAGES.cta} id="cta">
        <div className="ke-cta-section">
          <div className="ke-cta-inner">
            <AnimatedSection delay={1.2}>
              <div>
                <h2 className="ke-cta-h2">Find Your Ideal Home in Kolkata Today</h2>
                <p className="ke-cta-desc">
                  Whether you're exploring investment opportunities or searching for your family's next home,
                  our team of 250+ experts is ready to guide you — with verified listings, transparent deals,
                  and deep knowledge of every Kolkata micro-market.
                </p>
                <a href={`tel:${PHONE_NUMBER}`} className="ke-phone-row" onClick={handlePhoneClick}>
                  <div className="ke-phone-icon"><IconPhone /></div>
                  <div>
                    <p className="ke-phone-lbl">Call Us Now</p>
                    <p className="ke-phone-num">{PHONE_DISPLAY}</p>
                  </div>
                </a>
                <a href={`https://wa.me/${PHONE_NUMBER}`} className="ke-wa-btn" onClick={handleWhatsAppClick} target="_blank" rel="noopener noreferrer">
                  <IconWhatsapp /> WhatsApp Us
                </a>
                <button className="ke-btn-gold" style={{ width: "100%", justifyContent: "center" }} onClick={handleScheduleConsultation}>
                  Schedule a Consultation <IconArrow />
                </button>
              </div>
            </AnimatedSection>
            <AnimatedSection delay={1.2}>
              <div className="ke-contact-form">
                <div style={{ marginBottom: 4 }}>
                  <p style={{ fontFamily: "'Playfair Display', serif", fontSize: 18, color: "#f0e8d8" }}>Schedule a Callback</p>
                  <p style={{ fontSize: 12, color: "var(--text3)", marginTop: 4 }}>Our team will reach out within 2 hours</p>
                </div>
                <div className="ke-form-row">
                  <input 
                    className={`ke-form-input ${errors.firstName ? "error" : ""}`} 
                    placeholder="Your Name*" 
                    value={formData.firstName} 
                    onChange={e => setFormData({ ...formData, firstName: e.target.value })} 
                    required 
                  />
                  <input 
                    className={`ke-form-input ${errors.phone ? "error" : ""}`} 
                    placeholder="Mobile Number*" 
                    value={formData.phone} 
                    onChange={e => setFormData({ ...formData, phone: e.target.value })} 
                    required 
                  />
                </div>
                <input 
                  className={`ke-form-input ${errors.email ? "error" : ""}`} 
                  placeholder="Email Address*" 
                  type="email"
                  value={formData.email} 
                  onChange={e => setFormData({ ...formData, email: e.target.value })} 
                  required 
                />
                <input 
                  className="ke-form-input" 
                  placeholder="Locality / Project of Interest" 
                  value={formData.locality} 
                  onChange={e => setFormData({ ...formData, locality: e.target.value })} 
                />
                <select 
                  className="ke-form-input" 
                  style={{ cursor: "pointer" }} 
                  value={formData.budget} 
                  onChange={e => setFormData({ ...formData, budget: e.target.value })}
                >
                  <option value="">Budget Range</option>
                  <option>Under ₹50 Lac</option>
                  <option>₹50L – ₹1 Cr</option>
                  <option>₹1Cr – ₹2Cr</option>
                  <option>Above ₹2 Cr</option>
                </select>
                <button 
                  type="submit" 
                  className="ke-btn-gold" 
                  style={{ width: "100%", justifyContent: "center" }}
                  onClick={handleSubmitContact}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "SENDING..." : "Request Callback"}
                </button>
                <p style={{ fontSize: 10, color: "var(--text3)", textAlign: "center", marginTop: 10 }}>
                  No spam. 100% confidential.
                </p>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </BgSection>

      {/* ─── FLOATING WHATSAPP ── */}
      <a href={`https://wa.me/${PHONE_NUMBER}`} className="ke-float-wa" title="WhatsApp Us" target="_blank" rel="noopener noreferrer" onClick={handleWhatsAppClick}>
        <IconWhatsapp />
      </a>

      {/* ─── CUSTOM POPUP ── */}
      {isPopupOpen && (
        <ProjectPopup 
          project={selectedProject} 
          onClose={handleClosePopup} 
          phoneDisplay={PHONE_DISPLAY}
        />
      )}

      {/* ─── CONTACT MODAL ── */}
      {contactModalOpen && (
        <div className="ke-contact-modal-overlay" onClick={closeContactModal}>
          <div className="ke-contact-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="ke-contact-modal-close" onClick={closeContactModal}>
              <IconClose />
            </button>

            {!submitted && (
              <>
                <div className="ke-contact-steps">
                  <div className={`ke-contact-step-dot ${contactStep >= 1 ? "active" : ""}`} />
                  <div className={`ke-contact-step-dot ${contactStep >= 2 ? "active" : ""}`} />
                  <div className={`ke-contact-step-dot ${contactStep >= 3 ? "active" : ""}`} />
                </div>

                {contactStep === 1 && (
                  <div>
                    <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, color: "#f0e8d8", marginBottom: 6, textAlign: "center" }}>
                      Express Your Interest
                    </h3>
                    <p style={{ fontSize: 13, color: "var(--text3)", textAlign: "center", marginBottom: 24 }}>
                      Select what you're looking for
                    </p>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                      {[
                        { icon: "🏠", label: "Buy/Sell" },
                        { icon: "🔑", label: "Rent" },
                        { icon: "📊", label: "Manage" },
                        { icon: "💰", label: "Mortgage" },
                        { icon: "🏗️", label: "Off-Plan" },
                        { icon: "📋", label: "General" },
                      ].map((opt) => (
                        <button
                          key={opt.label}
                          onClick={() => handleInterestSelect(opt.label)}
                          style={{
                            padding: "16px",
                            border: `1px solid ${contactInterest === opt.label ? "var(--gold)" : "var(--border)"}`,
                            borderRadius: "8px",
                            background: contactInterest === opt.label ? "rgba(201,168,76,0.1)" : "transparent",
                            color: "var(--text)",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            textAlign: "center",
                          }}
                        >
                          <span style={{ fontSize: "28px", display: "block", marginBottom: "6px" }}>{opt.icon}</span>
                          <span style={{ fontSize: "12px", fontWeight: 600 }}>{opt.label}</span>
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {contactStep === 2 && (
                  <div>
                    <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, color: "#f0e8d8", marginBottom: 6, textAlign: "center" }}>
                      How Many Bedrooms?
                    </h3>
                    <p style={{ fontSize: 13, color: "var(--text3)", textAlign: "center", marginBottom: 24 }}>
                      Select your preference for {contactInterest}
                    </p>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: "8px" }}>
                      {["1", "2", "3", "4", "5+"].map((b) => (
                        <button
                          key={b}
                          onClick={() => handleBedSelect(b)}
                          style={{
                            padding: "14px",
                            border: `1px solid ${contactBeds === b ? "var(--gold)" : "var(--border)"}`,
                            borderRadius: "8px",
                            background: contactBeds === b ? "rgba(201,168,76,0.1)" : "transparent",
                            color: "var(--text)",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            textAlign: "center",
                            fontSize: "18px",
                            fontWeight: 600,
                          }}
                        >
                          {b}
                        </button>
                      ))}
                    </div>
                    <button
                      className="ke-btn-ghost"
                      style={{ width: "100%", justifyContent: "center", marginTop: "16px" }}
                      onClick={() => setContactStep(1)}
                    >
                      ← Back
                    </button>
                  </div>
                )}

                {contactStep === 3 && (
                  <div>
                    <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, color: "#f0e8d8", marginBottom: 6, textAlign: "center" }}>
                      Your Details
                    </h3>
                    <p style={{ fontSize: 13, color: "var(--text3)", textAlign: "center", marginBottom: 20 }}>
                      We'll reach out within 24 hours
                    </p>
                    <div className="ke-form-row">
                      <input
                        className={`ke-form-input ${errors.firstName ? "error" : ""}`}
                        placeholder="First Name*"
                        value={formData.firstName}
                        onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                      />
                      <input
                        className={`ke-form-input ${errors.lastName ? "error" : ""}`}
                        placeholder="Last Name*"
                        value={formData.lastName}
                        onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                      />
                    </div>
                    <input
                      className={`ke-form-input ${errors.email ? "error" : ""}`}
                      placeholder="Email Address*"
                      type="email"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    />
                    <input
                      className={`ke-form-input ${errors.phone ? "error" : ""}`}
                      placeholder="Phone Number*"
                      type="tel"
                      value={formData.phone}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    />
                    <textarea
                      className="ke-form-input"
                      placeholder="Your message (optional)..."
                      rows={2}
                      style={{ resize: "vertical" }}
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    />
                    <div style={{ 
                      background: "rgba(201,168,76,0.08)", 
                      border: "1px solid var(--border)", 
                      padding: "10px 14px", 
                      borderRadius: "6px",
                      fontSize: "13px",
                      color: "var(--dm)",
                      marginBottom: "10px"
                    }}>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "4px" }}>
                        <span>Interest:</span>
                        <span style={{ color: "var(--gold)", fontWeight: 600 }}>{contactInterest}</span>
                      </div>
                      {contactBeds && (
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <span>Bedrooms:</span>
                          <span style={{ color: "var(--gold)", fontWeight: 600 }}>{contactBeds}</span>
                        </div>
                      )}
                    </div>
                    <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                      <button
                        className="ke-btn-gold"
                        style={{ flex: 1, justifyContent: "center" }}
                        onClick={handleSubmitContact}
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "SENDING..." : "SUBMIT"}
                      </button>
                      <button
                        className="ke-btn-ghost"
                        style={{ padding: "12px 20px" }}
                        onClick={() => setContactStep(2)}
                      >
                        ← Back
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}

            {submitted && (
              <div style={{ textAlign: "center", padding: "30px 0" }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
                <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: 24, color: "#f0e8d8", marginBottom: 8 }}>
                  Thank You!
                </h3>
                <p style={{ fontSize: 14, color: "var(--text2)", lineHeight: 1.7 }}>
                  Our team will contact you within 24 hours to discuss your {contactInterest} requirements.
                </p>
                <button 
                  className="ke-btn-gold" 
                  style={{ marginTop: "24px", padding: "12px 28px" }}
                  onClick={() => {
                    setSubmitted(false);
                    setContactStep(1);
                    setContactInterest("");
                    setContactBeds("");
                    setFormData({ firstName: "", lastName: "", email: "", phone: "", message: "", locality: "", budget: "" });
                    setErrors({});
                    setContactModalOpen(false);
                    document.body.style.overflow = "unset";
                  }}
                >
                  CLOSE
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {toast && (
        <div className="ke-toast" id="ke-toast">
          {toast}
        </div>
      )}
    </div>
  ); 
}